var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _g2, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _g3, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 229,
    viewBox: "0 0 306 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.984 199.461H0.654297V199.619H305.984V199.461Z",
    fill: "#B3CCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M275.389 209.634H255.164V209.792H275.389V209.634Z",
    fill: "#B3CCE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.916 211.354H197.609V211.512H202.916V211.354Z",
    fill: "#B3CCE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.555 203.767H242.836V203.925H254.555V203.767Z",
    fill: "#B3CCE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0639 204.829H32.6895V204.987H59.0639V204.829Z",
    fill: "#B3CCE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3694 204.829H64.5039V204.987H68.3694V204.829Z",
    fill: "#B3CCE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.144 207.497H80.9375V207.655H138.144V207.497Z",
    fill: "#B3CCE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.06 38.395C127.061 37.2775 126.809 36.1752 126.325 35.1764C125.841 34.1775 125.138 33.3098 124.272 32.6425C123.406 31.9752 122.402 31.5269 121.339 31.3335C120.276 31.14 119.184 31.2067 118.15 31.5282C118.256 30.7999 118.309 30.0644 118.309 29.3278C118.308 27.0987 117.833 24.8972 116.918 22.8797C116.002 20.8622 114.668 19.0784 113.011 17.6551C111.355 16.2317 109.415 15.2038 107.331 14.6443C105.248 14.0849 103.07 14.0077 100.954 14.4182C99.5041 11.9691 97.326 10.073 94.7469 9.01439C92.1677 7.95579 89.3266 7.79182 86.6498 8.54708C83.973 9.30233 81.6049 10.9361 79.901 13.2032C78.197 15.4702 77.2491 18.2483 77.1995 21.1206H76.9857C73.9364 21.245 71.0519 22.5868 68.9369 24.8648C66.8219 27.1427 65.6406 30.1799 65.6406 33.3398C65.6406 36.4996 66.8219 39.5369 68.9369 41.8148C71.0519 44.0927 73.9364 45.4345 76.9857 45.559H120.343C122.143 45.5062 123.852 44.7281 125.107 43.3901C126.361 42.052 127.062 40.2599 127.06 38.395Z",
    fill: "#DCEAF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.693 70.4526C174.693 69.5084 174.331 68.603 173.686 67.9354C173.041 67.2678 172.167 66.8927 171.255 66.8927C170.92 66.8948 170.587 66.9459 170.266 67.0445C170.32 66.6826 170.346 66.3168 170.345 65.9506C170.345 63.956 169.581 62.0428 168.222 60.6301C166.862 59.2173 165.017 58.4203 163.09 58.4136C162.639 58.413 162.19 58.4574 161.747 58.5464C161.03 57.3258 159.948 56.3798 158.666 55.8509C157.385 55.3221 155.971 55.2391 154.64 55.6145C153.308 55.9898 152.131 56.8032 151.285 57.9319C150.439 59.0606 149.97 60.4436 149.949 61.8723H149.845C148.322 61.9231 146.878 62.5853 145.818 63.7187C144.759 64.8521 144.166 66.3679 144.166 67.9455C144.166 69.5231 144.759 71.0389 145.818 72.1723C146.878 73.3057 148.322 73.9678 149.845 74.0187H171.377C172.269 73.9875 173.114 73.5976 173.733 72.9318C174.352 72.2661 174.697 71.3767 174.693 70.4526Z",
    fill: "#DCEAF8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250.72 35.7899C250.72 35.5034 250.666 35.2198 250.56 34.9551C250.454 34.6905 250.299 34.45 250.103 34.2474C249.907 34.0448 249.675 33.8842 249.419 33.7745C249.164 33.6649 248.89 33.6085 248.613 33.6085C248.406 33.6106 248.201 33.6425 248.003 33.7033C248.034 33.4814 248.051 33.2574 248.051 33.0331C248.051 31.8089 247.582 30.6349 246.746 29.7692C245.91 28.9036 244.776 28.4173 243.594 28.4173C243.317 28.4169 243.041 28.4423 242.769 28.4932C242.33 27.7453 241.667 27.1656 240.882 26.8418C240.096 26.518 239.23 26.4676 238.415 26.6982C237.599 26.9288 236.878 27.4279 236.36 28.1201C235.843 28.8123 235.556 29.6601 235.545 30.5355H235.478C234.55 30.5751 233.674 30.9845 233.031 31.678C232.388 32.3715 232.029 33.2954 232.029 34.2566C232.029 35.2178 232.388 36.1417 233.031 36.8352C233.674 37.5287 234.55 37.9381 235.478 37.9777H248.668C249.218 37.9612 249.74 37.7235 250.123 37.315C250.506 36.9064 250.72 36.3594 250.72 35.7899Z",
    fill: "#DCEAF8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4105 26.5895V31.6804H84.794V27.2358H84.7642L83.5213 28.0611V27.4347L84.794 26.5895H85.4105ZM88.5352 31.75C88.1606 31.75 87.8416 31.6481 87.5781 31.4443C87.3146 31.2388 87.1133 30.9413 86.9741 30.5519C86.8349 30.1608 86.7653 29.6885 86.7653 29.135C86.7653 28.5848 86.8349 28.115 86.9741 27.7255C87.1149 27.3344 87.3171 27.0361 87.5806 26.8306C87.8458 26.6235 88.1639 26.5199 88.5352 26.5199C88.9064 26.5199 89.2237 26.6235 89.4872 26.8306C89.7524 27.0361 89.9545 27.3344 90.0938 27.7255C90.2346 28.115 90.305 28.5848 90.305 29.135C90.305 29.6885 90.2354 30.1608 90.0962 30.5519C89.957 30.9413 89.7557 31.2388 89.4922 31.4443C89.2287 31.6481 88.9097 31.75 88.5352 31.75ZM88.5352 31.2031C88.9064 31.2031 89.1947 31.0242 89.4002 30.6662C89.6057 30.3083 89.7085 29.7978 89.7085 29.135C89.7085 28.6942 89.6612 28.3188 89.5668 28.0089C89.474 27.699 89.3397 27.4629 89.1641 27.3004C88.9901 27.138 88.7804 27.0568 88.5352 27.0568C88.1673 27.0568 87.8797 27.2383 87.6726 27.6012C87.4654 27.9625 87.3619 28.4737 87.3619 29.135C87.3619 29.5758 87.4083 29.9503 87.5011 30.2585C87.5939 30.5668 87.7273 30.8013 87.9013 30.962C88.0769 31.1228 88.2882 31.2031 88.5352 31.2031ZM93.0394 26.5895V31.6804H92.4229V27.2358H92.3931L91.1502 28.0611V27.4347L92.4229 26.5895H93.0394ZM96.1641 31.75C95.7895 31.75 95.4705 31.6481 95.207 31.4443C94.9435 31.2388 94.7422 30.9413 94.603 30.5519C94.4638 30.1608 94.3942 29.6885 94.3942 29.135C94.3942 28.5848 94.4638 28.115 94.603 27.7255C94.7438 27.3344 94.946 27.0361 95.2095 26.8306C95.4747 26.6235 95.7929 26.5199 96.1641 26.5199C96.5353 26.5199 96.8526 26.6235 97.1161 26.8306C97.3813 27.0361 97.5835 27.3344 97.7227 27.7255C97.8635 28.115 97.9339 28.5848 97.9339 29.135C97.9339 29.6885 97.8643 30.1608 97.7251 30.5519C97.5859 30.9413 97.3846 31.2388 97.1211 31.4443C96.8576 31.6481 96.5386 31.75 96.1641 31.75ZM96.1641 31.2031C96.5353 31.2031 96.8236 31.0242 97.0291 30.6662C97.2346 30.3083 97.3374 29.7978 97.3374 29.135C97.3374 28.6942 97.2901 28.3188 97.1957 28.0089C97.1029 27.699 96.9686 27.4629 96.793 27.3004C96.619 27.138 96.4093 27.0568 96.1641 27.0568C95.7962 27.0568 95.5086 27.2383 95.3015 27.6012C95.0943 27.9625 94.9908 28.4737 94.9908 29.135C94.9908 29.5758 95.0372 29.9503 95.13 30.2585C95.2228 30.5668 95.3562 30.8013 95.5302 30.962C95.7058 31.1228 95.9171 31.2031 96.1641 31.2031ZM100.668 26.5895V31.6804H100.052V27.2358H100.022L98.7791 28.0611V27.4347L100.052 26.5895H100.668ZM103.793 31.75C103.418 31.75 103.099 31.6481 102.836 31.4443C102.572 31.2388 102.371 30.9413 102.232 30.5519C102.093 30.1608 102.023 29.6885 102.023 29.135C102.023 28.5848 102.093 28.115 102.232 27.7255C102.373 27.3344 102.575 27.0361 102.838 26.8306C103.104 26.6235 103.422 26.5199 103.793 26.5199C104.164 26.5199 104.482 26.6235 104.745 26.8306C105.01 27.0361 105.212 27.3344 105.352 27.7255C105.492 28.115 105.563 28.5848 105.563 29.135C105.563 29.6885 105.493 30.1608 105.354 30.5519C105.215 30.9413 105.013 31.2388 104.75 31.4443C104.487 31.6481 104.167 31.75 103.793 31.75ZM103.793 31.2031C104.164 31.2031 104.453 31.0242 104.658 30.6662C104.864 30.3083 104.966 29.7978 104.966 29.135C104.966 28.6942 104.919 28.3188 104.825 28.0089C104.732 27.699 104.598 27.4629 104.422 27.3004C104.248 27.138 104.038 27.0568 103.793 27.0568C103.425 27.0568 103.138 27.2383 102.93 27.6012C102.723 27.9625 102.62 28.4737 102.62 29.135C102.62 29.5758 102.666 29.9503 102.759 30.2585C102.852 30.5668 102.985 30.8013 103.159 30.962C103.335 31.1228 103.546 31.2031 103.793 31.2031ZM108.168 31.75C107.793 31.75 107.474 31.6481 107.211 31.4443C106.947 31.2388 106.746 30.9413 106.607 30.5519C106.468 30.1608 106.398 29.6885 106.398 29.135C106.398 28.5848 106.468 28.115 106.607 27.7255C106.748 27.3344 106.95 27.0361 107.213 26.8306C107.479 26.6235 107.797 26.5199 108.168 26.5199C108.539 26.5199 108.857 26.6235 109.12 26.8306C109.385 27.0361 109.587 27.3344 109.727 27.7255C109.867 28.115 109.938 28.5848 109.938 29.135C109.938 29.6885 109.868 30.1608 109.729 30.5519C109.59 30.9413 109.388 31.2388 109.125 31.4443C108.862 31.6481 108.542 31.75 108.168 31.75ZM108.168 31.2031C108.539 31.2031 108.828 31.0242 109.033 30.6662C109.239 30.3083 109.341 29.7978 109.341 29.135C109.341 28.6942 109.294 28.3188 109.2 28.0089C109.107 27.699 108.973 27.4629 108.797 27.3004C108.623 27.138 108.413 27.0568 108.168 27.0568C107.8 27.0568 107.513 27.2383 107.305 27.6012C107.098 27.9625 106.995 28.4737 106.995 29.135C106.995 29.5758 107.041 29.9503 107.134 30.2585C107.227 30.5668 107.36 30.8013 107.534 30.962C107.71 31.1228 107.921 31.2031 108.168 31.2031ZM112.543 31.75C112.168 31.75 111.849 31.6481 111.586 31.4443C111.322 31.2388 111.121 30.9413 110.982 30.5519C110.843 30.1608 110.773 29.6885 110.773 29.135C110.773 28.5848 110.843 28.115 110.982 27.7255C111.123 27.3344 111.325 27.0361 111.588 26.8306C111.854 26.6235 112.172 26.5199 112.543 26.5199C112.914 26.5199 113.232 26.6235 113.495 26.8306C113.76 27.0361 113.962 27.3344 114.102 27.7255C114.242 28.115 114.313 28.5848 114.313 29.135C114.313 29.6885 114.243 30.1608 114.104 30.5519C113.965 30.9413 113.763 31.2388 113.5 31.4443C113.237 31.6481 112.917 31.75 112.543 31.75ZM112.543 31.2031C112.914 31.2031 113.203 31.0242 113.408 30.6662C113.614 30.3083 113.716 29.7978 113.716 29.135C113.716 28.6942 113.669 28.3188 113.575 28.0089C113.482 27.699 113.348 27.4629 113.172 27.3004C112.998 27.138 112.788 27.0568 112.543 27.0568C112.175 27.0568 111.888 27.2383 111.68 27.6012C111.473 27.9625 111.37 28.4737 111.37 29.135C111.37 29.5758 111.416 29.9503 111.509 30.2585C111.602 30.5668 111.735 30.8013 111.909 30.962C112.085 31.1228 112.296 31.2031 112.543 31.2031ZM116.918 31.75C116.543 31.75 116.224 31.6481 115.961 31.4443C115.697 31.2388 115.496 30.9413 115.357 30.5519C115.218 30.1608 115.148 29.6885 115.148 29.135C115.148 28.5848 115.218 28.115 115.357 27.7255C115.498 27.3344 115.7 27.0361 115.963 26.8306C116.229 26.6235 116.547 26.5199 116.918 26.5199C117.289 26.5199 117.607 26.6235 117.87 26.8306C118.135 27.0361 118.337 27.3344 118.477 27.7255C118.617 28.115 118.688 28.5848 118.688 29.135C118.688 29.6885 118.618 30.1608 118.479 30.5519C118.34 30.9413 118.138 31.2388 117.875 31.4443C117.612 31.6481 117.292 31.75 116.918 31.75ZM116.918 31.2031C117.289 31.2031 117.578 31.0242 117.783 30.6662C117.989 30.3083 118.091 29.7978 118.091 29.135C118.091 28.6942 118.044 28.3188 117.95 28.0089C117.857 27.699 117.723 27.4629 117.547 27.3004C117.373 27.138 117.163 27.0568 116.918 27.0568C116.55 27.0568 116.263 27.2383 116.055 27.6012C115.848 27.9625 115.745 28.4737 115.745 29.135C115.745 29.5758 115.791 29.9503 115.884 30.2585C115.977 30.5668 116.11 30.8013 116.284 30.962C116.46 31.1228 116.671 31.2031 116.918 31.2031ZM121.422 26.5895V31.6804H120.806V27.2358H120.776L119.533 28.0611V27.4347L120.806 26.5895H121.422ZM124.676 26.5895V31.6804H124.06V27.2358H124.03L122.787 28.0611V27.4347L124.06 26.5895H124.676ZM127.93 26.5895V31.6804H127.314V27.2358H127.284L126.041 28.0611V27.4347L127.314 26.5895H127.93ZM131.184 26.5895V31.6804H130.567V27.2358H130.538L129.295 28.0611V27.4347L130.567 26.5895H131.184ZM134.438 26.5895V31.6804H133.821V27.2358H133.792L132.549 28.0611V27.4347L133.821 26.5895H134.438ZM85.2812 39.75C84.9067 39.75 84.5877 39.6481 84.3242 39.4443C84.0607 39.2388 83.8594 38.9413 83.7202 38.5519C83.581 38.1608 83.5114 37.6885 83.5114 37.135C83.5114 36.5848 83.581 36.115 83.7202 35.7255C83.861 35.3344 84.0632 35.0361 84.3267 34.8306C84.5919 34.6235 84.91 34.5199 85.2812 34.5199C85.6525 34.5199 85.9698 34.6235 86.2333 34.8306C86.4985 35.0361 86.7006 35.3344 86.8398 35.7255C86.9807 36.115 87.0511 36.5848 87.0511 37.135C87.0511 37.6885 86.9815 38.1608 86.8423 38.5519C86.7031 38.9413 86.5018 39.2388 86.2383 39.4443C85.9748 39.6481 85.6558 39.75 85.2812 39.75ZM85.2812 39.2031C85.6525 39.2031 85.9408 39.0242 86.1463 38.6662C86.3518 38.3083 86.4545 37.7978 86.4545 37.135C86.4545 36.6942 86.4073 36.3188 86.3129 36.0089C86.2201 35.699 86.0858 35.4629 85.9102 35.3004C85.7362 35.138 85.5265 35.0568 85.2812 35.0568C84.9134 35.0568 84.6258 35.2383 84.4187 35.6012C84.2115 35.9625 84.108 36.4737 84.108 37.135C84.108 37.5758 84.1544 37.9503 84.2472 38.2585C84.34 38.5668 84.4734 38.8013 84.6474 38.962C84.823 39.1228 85.0343 39.2031 85.2812 39.2031ZM89.7855 34.5895V39.6804H89.169V35.2358H89.1392L87.8963 36.0611V35.4347L89.169 34.5895H89.7855ZM92.9102 39.75C92.5356 39.75 92.2166 39.6481 91.9531 39.4443C91.6896 39.2388 91.4883 38.9413 91.3491 38.5519C91.2099 38.1608 91.1403 37.6885 91.1403 37.135C91.1403 36.5848 91.2099 36.115 91.3491 35.7255C91.4899 35.3344 91.6921 35.0361 91.9556 34.8306C92.2208 34.6235 92.5389 34.5199 92.9102 34.5199C93.2814 34.5199 93.5987 34.6235 93.8622 34.8306C94.1274 35.0361 94.3295 35.3344 94.4688 35.7255C94.6096 36.115 94.68 36.5848 94.68 37.135C94.68 37.6885 94.6104 38.1608 94.4712 38.5519C94.332 38.9413 94.1307 39.2388 93.8672 39.4443C93.6037 39.6481 93.2847 39.75 92.9102 39.75ZM92.9102 39.2031C93.2814 39.2031 93.5697 39.0242 93.7752 38.6662C93.9807 38.3083 94.0835 37.7978 94.0835 37.135C94.0835 36.6942 94.0362 36.3188 93.9418 36.0089C93.849 35.699 93.7147 35.4629 93.5391 35.3004C93.3651 35.138 93.1554 35.0568 92.9102 35.0568C92.5423 35.0568 92.2547 35.2383 92.0476 35.6012C91.8404 35.9625 91.7369 36.4737 91.7369 37.135C91.7369 37.5758 91.7833 37.9503 91.8761 38.2585C91.9689 38.5668 92.1023 38.8013 92.2763 38.962C92.4519 39.1228 92.6632 39.2031 92.9102 39.2031ZM97.4144 34.5895V39.6804H96.7979V35.2358H96.7681L95.5252 36.0611V35.4347L96.7979 34.5895H97.4144ZM100.539 39.75C100.165 39.75 99.8455 39.6481 99.582 39.4443C99.3185 39.2388 99.1172 38.9413 98.978 38.5519C98.8388 38.1608 98.7692 37.6885 98.7692 37.135C98.7692 36.5848 98.8388 36.115 98.978 35.7255C99.1188 35.3344 99.321 35.0361 99.5845 34.8306C99.8497 34.6235 100.168 34.5199 100.539 34.5199C100.91 34.5199 101.228 34.6235 101.491 34.8306C101.756 35.0361 101.958 35.3344 102.098 35.7255C102.239 36.115 102.309 36.5848 102.309 37.135C102.309 37.6885 102.239 38.1608 102.1 38.5519C101.961 38.9413 101.76 39.2388 101.496 39.4443C101.233 39.6481 100.914 39.75 100.539 39.75ZM100.539 39.2031C100.91 39.2031 101.199 39.0242 101.404 38.6662C101.61 38.3083 101.712 37.7978 101.712 37.135C101.712 36.6942 101.665 36.3188 101.571 36.0089C101.478 35.699 101.344 35.4629 101.168 35.3004C100.994 35.138 100.784 35.0568 100.539 35.0568C100.171 35.0568 99.8836 35.2383 99.6765 35.6012C99.4693 35.9625 99.3658 36.4737 99.3658 37.135C99.3658 37.5758 99.4122 37.9503 99.505 38.2585C99.5978 38.5668 99.7312 38.8013 99.9052 38.962C100.081 39.1228 100.292 39.2031 100.539 39.2031ZM105.043 34.5895V39.6804H104.427V35.2358H104.397L103.154 36.0611V35.4347L104.427 34.5895H105.043ZM108.168 39.75C107.793 39.75 107.474 39.6481 107.211 39.4443C106.947 39.2388 106.746 38.9413 106.607 38.5519C106.468 38.1608 106.398 37.6885 106.398 37.135C106.398 36.5848 106.468 36.115 106.607 35.7255C106.748 35.3344 106.95 35.0361 107.213 34.8306C107.479 34.6235 107.797 34.5199 108.168 34.5199C108.539 34.5199 108.857 34.6235 109.12 34.8306C109.385 35.0361 109.587 35.3344 109.727 35.7255C109.867 36.115 109.938 36.5848 109.938 37.135C109.938 37.6885 109.868 38.1608 109.729 38.5519C109.59 38.9413 109.388 39.2388 109.125 39.4443C108.862 39.6481 108.542 39.75 108.168 39.75ZM108.168 39.2031C108.539 39.2031 108.828 39.0242 109.033 38.6662C109.239 38.3083 109.341 37.7978 109.341 37.135C109.341 36.6942 109.294 36.3188 109.2 36.0089C109.107 35.699 108.973 35.4629 108.797 35.3004C108.623 35.138 108.413 35.0568 108.168 35.0568C107.8 35.0568 107.513 35.2383 107.305 35.6012C107.098 35.9625 106.995 36.4737 106.995 37.135C106.995 37.5758 107.041 37.9503 107.134 38.2585C107.227 38.5668 107.36 38.8013 107.534 38.962C107.71 39.1228 107.921 39.2031 108.168 39.2031ZM112.672 34.5895V39.6804H112.056V35.2358H112.026L110.783 36.0611V35.4347L112.056 34.5895H112.672ZM115.797 39.75C115.422 39.75 115.103 39.6481 114.84 39.4443C114.576 39.2388 114.375 38.9413 114.236 38.5519C114.097 38.1608 114.027 37.6885 114.027 37.135C114.027 36.5848 114.097 36.115 114.236 35.7255C114.377 35.3344 114.579 35.0361 114.842 34.8306C115.107 34.6235 115.426 34.5199 115.797 34.5199C116.168 34.5199 116.485 34.6235 116.749 34.8306C117.014 35.0361 117.216 35.3344 117.355 35.7255C117.496 36.115 117.567 36.5848 117.567 37.135C117.567 37.6885 117.497 38.1608 117.358 38.5519C117.219 38.9413 117.017 39.2388 116.754 39.4443C116.49 39.6481 116.171 39.75 115.797 39.75ZM115.797 39.2031C116.168 39.2031 116.456 39.0242 116.662 38.6662C116.867 38.3083 116.97 37.7978 116.97 37.135C116.97 36.6942 116.923 36.3188 116.828 36.0089C116.736 35.699 116.601 35.4629 116.426 35.3004C116.252 35.138 116.042 35.0568 115.797 35.0568C115.429 35.0568 115.141 35.2383 114.934 35.6012C114.727 35.9625 114.624 36.4737 114.624 37.135C114.624 37.5758 114.67 37.9503 114.763 38.2585C114.856 38.5668 114.989 38.8013 115.163 38.962C115.339 39.1228 115.55 39.2031 115.797 39.2031ZM120.301 34.5895V39.6804H119.685V35.2358H119.655L118.412 36.0611V35.4347L119.685 34.5895H120.301Z",
    fill: "#B3CCE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M166.76 108.568H28.4395V199.669H166.76V108.568Z",
    fill: "#DCEAF8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.76 108.568H28.4395V114.739H166.76V108.568Z",
    fill: "#B3CCE5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M164.702 111.653C164.702 112.021 164.597 112.38 164.399 112.686C164.202 112.992 163.922 113.23 163.594 113.371C163.266 113.511 162.905 113.548 162.556 113.476C162.208 113.405 161.888 113.228 161.637 112.968C161.386 112.708 161.215 112.376 161.146 112.016C161.077 111.655 161.112 111.281 161.248 110.942C161.384 110.602 161.614 110.312 161.909 110.107C162.204 109.903 162.552 109.794 162.907 109.794C163.383 109.794 163.839 109.99 164.176 110.339C164.513 110.687 164.702 111.16 164.702 111.653Z",
    fill: "#DCEAF8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.735 111.653C158.735 112.021 158.63 112.38 158.433 112.686C158.235 112.992 157.955 113.23 157.627 113.371C157.299 113.511 156.938 113.548 156.59 113.476C156.241 113.405 155.921 113.228 155.67 112.968C155.419 112.708 155.248 112.376 155.179 112.016C155.11 111.655 155.145 111.281 155.281 110.942C155.417 110.602 155.647 110.312 155.942 110.107C156.238 109.903 156.585 109.794 156.94 109.794C157.416 109.796 157.871 109.992 158.208 110.341C158.544 110.689 158.734 111.161 158.735 111.653Z",
    fill: "#DCEAF8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.764 111.653C152.764 112.021 152.659 112.38 152.462 112.686C152.265 112.992 151.984 113.23 151.656 113.371C151.328 113.511 150.967 113.548 150.619 113.476C150.271 113.405 149.951 113.228 149.7 112.968C149.449 112.708 149.278 112.376 149.208 112.016C149.139 111.655 149.175 111.281 149.31 110.942C149.446 110.602 149.676 110.312 149.972 110.107C150.267 109.903 150.614 109.794 150.969 109.794C151.445 109.794 151.902 109.99 152.239 110.339C152.575 110.687 152.764 111.16 152.764 111.653Z",
    fill: "#DCEAF8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4525 125.444L52.6037 124.217C52.453 123.998 52.2545 123.818 52.0243 123.693C51.7941 123.567 51.5386 123.5 51.2785 123.496H45.2757C45.0297 123.498 44.7882 123.566 44.5744 123.692C44.3607 123.818 44.1816 123.999 44.0544 124.217L43.34 125.444C43.2128 125.662 43.0337 125.843 42.8199 125.969C42.6061 126.095 42.3647 126.162 42.1186 126.165H38.5157C38.3149 126.16 38.1153 126.198 37.9296 126.277C37.7438 126.357 37.5759 126.475 37.4365 126.624C37.297 126.774 37.1891 126.952 37.1194 127.147C37.0498 127.342 37.02 127.55 37.0318 127.758L38.1921 148.504C38.2182 148.937 38.4011 149.345 38.7044 149.645C39.0078 149.945 39.4092 150.115 39.8287 150.122H68.206C68.4065 150.123 68.6049 150.081 68.7888 149.998C68.9727 149.915 69.1381 149.794 69.2746 149.642C69.4111 149.49 69.5158 149.31 69.582 149.115C69.6482 148.919 69.6746 148.711 69.6594 148.504L68.4991 127.758C68.4731 127.326 68.2908 126.92 67.9886 126.621C67.6864 126.323 67.2865 126.153 66.8687 126.146H54.7776C54.5191 126.144 54.2647 126.079 54.0345 125.958C53.8044 125.836 53.6051 125.66 53.4525 125.444Z",
    fill: "#B3CCE5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7027 128.137H43.7069C43.1742 128.145 42.6626 128.354 42.2688 128.726C41.875 129.098 41.6263 129.606 41.5696 130.154L40.0063 148.124C39.9794 148.381 40.0057 148.642 40.0835 148.888C40.1613 149.133 40.2888 149.359 40.4575 149.55C40.6262 149.741 40.8323 149.892 41.062 149.994C41.2916 150.096 41.5396 150.146 41.7895 150.141H67.7914C68.3237 150.132 68.8346 149.922 69.2281 149.551C69.6217 149.18 69.8708 148.672 69.9287 148.124L71.492 130.154C71.519 129.896 71.4925 129.636 71.4144 129.389C71.3362 129.143 71.2082 128.917 71.0388 128.726C70.8694 128.535 70.6626 128.384 70.4322 128.282C70.2018 128.181 69.9531 128.131 69.7027 128.137Z",
    fill: "#C5E0FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7417 125.444L95.9173 124.217C95.7667 123.998 95.5682 123.818 95.338 123.693C95.1077 123.567 94.8522 123.5 94.5922 123.496H88.5894C88.3434 123.499 88.1022 123.567 87.8885 123.693C87.6748 123.819 87.4957 123.999 87.3681 124.217L86.6536 125.444C86.5264 125.662 86.3474 125.843 86.1336 125.969C85.9198 126.095 85.6784 126.162 85.4323 126.165H81.8538C81.6534 126.163 81.4548 126.205 81.2707 126.287C81.0865 126.368 80.9206 126.489 80.7836 126.64C80.6465 126.792 80.5412 126.971 80.4742 127.166C80.4072 127.362 80.38 127.57 80.3943 127.777L81.5546 148.523C81.5786 148.94 81.7477 149.333 82.0307 149.631C82.3136 149.929 82.6912 150.11 83.0935 150.141H111.471C111.672 150.143 111.87 150.101 112.055 150.019C112.239 149.937 112.405 149.815 112.542 149.663C112.678 149.511 112.783 149.331 112.849 149.135C112.915 148.938 112.94 148.73 112.924 148.523L111.794 127.758C111.766 127.326 111.582 126.921 111.279 126.623C110.976 126.324 110.576 126.154 110.158 126.146H98.0729C97.8134 126.145 97.5577 126.081 97.3265 125.959C97.0952 125.837 96.8949 125.661 96.7417 125.444Z",
    fill: "#B3CCE5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M113.016 128.137H86.996C86.4633 128.145 85.9517 128.354 85.5579 128.726C85.1641 129.098 84.9154 129.606 84.8587 130.154L83.2954 148.124C83.2684 148.382 83.2949 148.643 83.373 148.889C83.4512 149.135 83.5792 149.362 83.7486 149.553C83.918 149.744 84.1248 149.895 84.3552 149.996C84.5856 150.098 84.8343 150.147 85.0847 150.141H111.08C111.613 150.132 112.124 149.922 112.517 149.551C112.911 149.18 113.16 148.672 113.218 148.124L114.781 130.154C114.808 129.899 114.782 129.64 114.705 129.396C114.629 129.151 114.503 128.926 114.336 128.736C114.169 128.545 113.965 128.393 113.738 128.29C113.511 128.187 113.265 128.135 113.016 128.137Z",
    fill: "#C5E0FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M140.039 125.444L139.184 124.217C139.034 123.997 138.835 123.817 138.605 123.691C138.375 123.566 138.119 123.499 137.859 123.496H131.856C131.61 123.499 131.369 123.567 131.155 123.693C130.941 123.819 130.762 123.999 130.634 124.217L129.92 125.444C129.793 125.662 129.614 125.843 129.4 125.969C129.186 126.095 128.945 126.162 128.699 126.165H125.12C124.92 126.162 124.721 126.203 124.537 126.285C124.352 126.366 124.186 126.487 124.05 126.638C123.913 126.79 123.808 126.97 123.742 127.166C123.676 127.362 123.651 127.57 123.667 127.777L124.821 148.523C124.85 148.955 125.034 149.361 125.336 149.66C125.639 149.96 126.039 150.131 126.458 150.141H154.786C154.987 150.143 155.186 150.101 155.371 150.019C155.555 149.937 155.721 149.816 155.859 149.663C155.996 149.511 156.101 149.331 156.168 149.135C156.234 148.939 156.261 148.73 156.245 148.523L155.085 127.758C155.059 127.325 154.876 126.918 154.572 126.619C154.269 126.32 153.868 126.151 153.449 126.146H141.364C141.105 126.145 140.85 126.081 140.62 125.959C140.39 125.837 140.191 125.66 140.039 125.444Z",
    fill: "#B3CCE5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M156.281 128.137H130.285C129.753 128.146 129.242 128.356 128.848 128.728C128.455 129.099 128.206 129.606 128.148 130.154L126.584 148.124C126.557 148.382 126.584 148.643 126.662 148.889C126.74 149.135 126.868 149.362 127.038 149.553C127.207 149.743 127.414 149.895 127.644 149.996C127.875 150.098 128.123 150.147 128.374 150.141H154.37C154.902 150.132 155.413 149.922 155.806 149.551C156.2 149.18 156.449 148.672 156.507 148.124L158.07 130.154C158.097 129.896 158.071 129.636 157.993 129.389C157.914 129.143 157.786 128.917 157.617 128.726C157.448 128.535 157.241 128.384 157.01 128.282C156.78 128.181 156.531 128.131 156.281 128.137Z",
    fill: "#C5E0FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4527 163.407L52.6039 162.18C52.4532 161.961 52.2547 161.781 52.0245 161.656C51.7943 161.531 51.5388 161.463 51.2787 161.459H45.2759C45.0299 161.462 44.7884 161.529 44.5746 161.655C44.3608 161.781 44.1818 161.962 44.0546 162.18L43.3401 163.407C43.2129 163.625 43.0339 163.806 42.8201 163.932C42.6063 164.058 42.3649 164.126 42.1188 164.128H38.5159C38.3155 164.126 38.117 164.168 37.9328 164.25C37.7486 164.332 37.5828 164.452 37.4457 164.604C37.3086 164.755 37.2033 164.934 37.1363 165.13C37.0693 165.325 37.0421 165.533 37.0564 165.74L38.2167 186.486C38.2428 186.919 38.426 187.326 38.7295 187.625C39.033 187.924 39.4344 188.093 39.8533 188.098H68.2306C68.4308 188.1 68.6291 188.058 68.813 187.976C68.9969 187.894 69.1624 187.774 69.299 187.622C69.4356 187.471 69.5403 187.291 69.6066 187.096C69.6729 186.9 69.6992 186.693 69.684 186.486L68.5238 165.74C68.4977 165.308 68.3154 164.903 68.0132 164.604C67.711 164.305 67.3111 164.135 66.8933 164.128H54.7778C54.5178 164.124 54.2623 164.057 54.032 163.931C53.8018 163.806 53.6033 163.626 53.4527 163.407Z",
    fill: "#B3CCE5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7028 166.1H43.707C43.1742 166.108 42.6626 166.318 42.2689 166.689C41.8751 167.061 41.6263 167.569 41.5697 168.117L40.0064 186.087C39.9794 186.344 40.0057 186.604 40.0835 186.85C40.1613 187.095 40.2889 187.321 40.4578 187.511C40.6266 187.702 40.8327 187.853 41.0624 187.954C41.2921 188.055 41.54 188.104 41.7895 188.098H67.7914C68.3232 188.091 68.8341 187.882 69.2277 187.512C69.6214 187.141 69.8707 186.635 69.9287 186.087L71.492 168.117C71.519 167.86 71.4926 167.599 71.4144 167.353C71.3363 167.106 71.2082 166.88 71.0388 166.689C70.8695 166.498 70.6626 166.347 70.4322 166.245C70.2018 166.144 69.9531 166.094 69.7028 166.1Z",
    fill: "#C5E0FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7417 163.407L95.9173 162.18C95.7667 161.961 95.5682 161.781 95.338 161.656C95.1077 161.531 94.8522 161.463 94.5922 161.459H88.5894C88.3434 161.462 88.1022 161.53 87.8885 161.656C87.6748 161.782 87.4957 161.963 87.3681 162.18L86.6536 163.407C86.5264 163.625 86.3474 163.806 86.1336 163.932C85.9198 164.058 85.6784 164.126 85.4323 164.128H81.8538C81.6534 164.126 81.4548 164.168 81.2707 164.25C81.0865 164.332 80.9206 164.452 80.7836 164.604C80.6465 164.755 80.5412 164.934 80.4742 165.13C80.4072 165.325 80.38 165.533 80.3943 165.74L81.5546 186.486C81.5807 186.919 81.7639 187.326 82.0674 187.625C82.3709 187.924 82.7723 188.093 83.1912 188.098H111.569C111.769 188.101 111.968 188.06 112.152 187.978C112.336 187.897 112.502 187.776 112.639 187.624C112.776 187.473 112.88 187.293 112.946 187.097C113.012 186.901 113.038 186.693 113.022 186.486L111.794 165.74C111.766 165.308 111.582 164.903 111.279 164.605C110.976 164.306 110.576 164.136 110.158 164.128H98.0729C97.8119 164.125 97.5552 164.058 97.3238 163.933C97.0924 163.808 96.893 163.627 96.7417 163.407Z",
    fill: "#B3CCE5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M113.016 166.101H86.9961C86.4633 166.108 85.9517 166.318 85.5579 166.689C85.1641 167.061 84.9154 167.569 84.8588 168.118L83.2955 186.088C83.2684 186.345 83.2948 186.605 83.373 186.852C83.4512 187.098 83.5794 187.323 83.7489 187.514C83.9183 187.704 84.1252 187.855 84.3557 187.956C84.5861 188.057 84.8347 188.105 85.0847 188.098H111.081C111.612 188.091 112.123 187.882 112.517 187.512C112.91 187.141 113.16 186.635 113.218 186.088L114.781 168.118C114.808 167.862 114.782 167.603 114.705 167.359C114.629 167.114 114.503 166.889 114.336 166.699C114.169 166.508 113.965 166.356 113.738 166.253C113.511 166.15 113.265 166.098 113.016 166.101Z",
    fill: "#C5E0FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140.039 163.407L139.184 162.18C139.034 161.96 138.835 161.78 138.605 161.655C138.375 161.529 138.119 161.462 137.859 161.459H131.856C131.61 161.462 131.369 161.53 131.155 161.656C130.941 161.782 130.762 161.963 130.634 162.18L129.92 163.407C129.793 163.625 129.614 163.806 129.4 163.932C129.186 164.058 128.945 164.126 128.699 164.128H125.12C124.92 164.125 124.721 164.166 124.537 164.248C124.352 164.329 124.186 164.45 124.05 164.602C123.913 164.753 123.808 164.933 123.742 165.129C123.676 165.325 123.651 165.533 123.667 165.74L124.821 186.486C124.85 186.918 125.034 187.323 125.337 187.621C125.64 187.92 126.039 188.09 126.458 188.098H154.786C154.986 188.1 155.185 188.058 155.369 187.976C155.553 187.894 155.719 187.774 155.856 187.623C155.993 187.471 156.099 187.292 156.166 187.096C156.233 186.901 156.26 186.693 156.246 186.486L155.085 165.74C155.059 165.307 154.876 164.901 154.572 164.602C154.269 164.303 153.868 164.133 153.449 164.128H141.364C141.103 164.125 140.848 164.058 140.617 163.933C140.387 163.807 140.189 163.627 140.039 163.407Z",
    fill: "#B3CCE5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M156.281 166.1H130.285C129.753 166.11 129.242 166.319 128.848 166.691C128.455 167.062 128.206 167.569 128.148 168.117L126.585 186.087C126.557 186.345 126.584 186.605 126.662 186.851C126.74 187.097 126.868 187.323 127.038 187.514C127.207 187.704 127.414 187.855 127.645 187.956C127.875 188.057 128.124 188.105 128.374 188.098H154.37C154.901 188.091 155.412 187.882 155.806 187.512C156.199 187.141 156.449 186.635 156.507 186.087L158.07 168.117C158.097 167.86 158.071 167.599 157.993 167.353C157.914 167.106 157.786 166.88 157.617 166.689C157.448 166.498 157.241 166.347 157.01 166.245C156.78 166.144 156.531 166.094 156.281 166.1Z",
    fill: "#C5E0FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M275.464 184.766H230.892C229.992 184.766 229.262 185.522 229.262 186.454V197.621C229.262 198.553 229.992 199.309 230.892 199.309H275.464C276.365 199.309 277.095 198.553 277.095 197.621V186.454C277.095 185.522 276.365 184.766 275.464 184.766Z",
    fill: "#C5E0FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M272.399 192.037C272.399 192.641 272.226 193.232 271.902 193.734C271.578 194.236 271.117 194.628 270.578 194.859C270.039 195.09 269.446 195.151 268.874 195.033C268.302 194.915 267.776 194.624 267.364 194.197C266.951 193.77 266.67 193.226 266.557 192.633C266.443 192.041 266.501 191.427 266.725 190.869C266.948 190.311 267.326 189.834 267.811 189.498C268.296 189.163 268.866 188.983 269.45 188.983C270.231 188.985 270.981 189.307 271.533 189.88C272.086 190.452 272.397 191.228 272.399 192.037Z",
    fill: "#DCEAF8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M270.926 192.038C270.926 192.345 270.838 192.646 270.673 192.902C270.508 193.157 270.273 193.357 269.999 193.475C269.724 193.592 269.422 193.623 269.131 193.563C268.84 193.503 268.572 193.355 268.362 193.137C268.152 192.92 268.009 192.643 267.951 192.341C267.893 192.039 267.923 191.726 268.036 191.442C268.15 191.158 268.342 190.915 268.59 190.744C268.837 190.573 269.127 190.482 269.424 190.482C269.823 190.482 270.205 190.646 270.486 190.938C270.768 191.229 270.926 191.625 270.926 192.038Z",
    fill: "#C5E0FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M263.097 190.299H259.738V193.776H263.097V190.299Z",
    fill: "#DCEAF8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M275.464 169.591H230.892C229.992 169.591 229.262 170.347 229.262 171.279V182.445C229.262 183.378 229.992 184.134 230.892 184.134H275.464C276.365 184.134 277.095 183.378 277.095 182.445V171.279C277.095 170.347 276.365 169.591 275.464 169.591Z",
    fill: "#C5E0FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M272.399 176.862C272.399 177.466 272.226 178.057 271.902 178.559C271.578 179.061 271.117 179.453 270.578 179.684C270.039 179.915 269.446 179.975 268.874 179.858C268.302 179.74 267.776 179.449 267.364 179.022C266.951 178.595 266.67 178.05 266.557 177.458C266.443 176.866 266.501 176.252 266.725 175.694C266.948 175.135 267.326 174.659 267.811 174.323C268.296 173.987 268.866 173.808 269.45 173.808C270.231 173.81 270.981 174.132 271.533 174.705C272.086 175.277 272.397 176.053 272.399 176.862Z",
    fill: "#DCEAF8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M270.926 176.862C270.926 177.17 270.838 177.471 270.673 177.726C270.508 177.982 270.273 178.182 269.999 178.299C269.724 178.417 269.422 178.448 269.131 178.388C268.84 178.328 268.572 178.18 268.362 177.962C268.152 177.745 268.009 177.467 267.951 177.166C267.893 176.864 267.923 176.551 268.036 176.267C268.15 175.983 268.342 175.74 268.59 175.569C268.837 175.398 269.127 175.307 269.424 175.307C269.823 175.307 270.205 175.471 270.486 175.762C270.768 176.054 270.926 176.45 270.926 176.862Z",
    fill: "#C5E0FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M263.097 175.123H259.738V178.601H263.097V175.123Z",
    fill: "#DCEAF8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M275.464 154.416H230.892C229.992 154.416 229.262 155.171 229.262 156.104V167.27C229.262 168.203 229.992 168.958 230.892 168.958H275.464C276.365 168.958 277.095 168.203 277.095 167.27V156.104C277.095 155.171 276.365 154.416 275.464 154.416Z",
    fill: "#C5E0FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M272.399 161.687C272.399 162.291 272.226 162.882 271.902 163.384C271.578 163.886 271.117 164.277 270.578 164.509C270.039 164.74 269.446 164.8 268.874 164.682C268.302 164.565 267.776 164.274 267.364 163.847C266.951 163.419 266.67 162.875 266.557 162.283C266.443 161.69 266.501 161.076 266.725 160.518C266.948 159.96 267.326 159.483 267.811 159.148C268.296 158.812 268.866 158.633 269.45 158.633C270.231 158.635 270.981 158.957 271.533 159.529C272.086 160.102 272.397 160.878 272.399 161.687Z",
    fill: "#DCEAF8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M270.926 161.687C270.926 161.995 270.838 162.295 270.673 162.551C270.508 162.807 270.273 163.006 269.999 163.124C269.724 163.242 269.422 163.273 269.131 163.213C268.84 163.153 268.572 163.004 268.362 162.787C268.152 162.569 268.009 162.292 267.951 161.99C267.893 161.689 267.923 161.376 268.036 161.092C268.15 160.808 268.342 160.565 268.59 160.394C268.837 160.223 269.127 160.132 269.424 160.132C269.823 160.132 270.205 160.295 270.486 160.587C270.768 160.879 270.926 161.275 270.926 161.687Z",
    fill: "#C5E0FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M263.097 159.948H259.738V163.426H263.097V159.948Z",
    fill: "#DCEAF8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M275.464 139.24H230.892C229.992 139.24 229.262 139.996 229.262 140.929V152.095C229.262 153.027 229.992 153.783 230.892 153.783H275.464C276.365 153.783 277.095 153.027 277.095 152.095V140.929C277.095 139.996 276.365 139.24 275.464 139.24Z",
    fill: "#C5E0FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M272.399 146.512C272.399 147.116 272.226 147.706 271.902 148.209C271.578 148.711 271.117 149.102 270.578 149.333C270.039 149.565 269.446 149.625 268.874 149.507C268.302 149.389 267.776 149.099 267.364 148.671C266.951 148.244 266.67 147.7 266.557 147.108C266.443 146.515 266.501 145.901 266.725 145.343C266.948 144.785 267.326 144.308 267.811 143.973C268.296 143.637 268.866 143.458 269.45 143.458C270.231 143.46 270.981 143.782 271.533 144.354C272.086 144.927 272.397 145.702 272.399 146.512Z",
    fill: "#DCEAF8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M270.926 146.512C270.926 146.82 270.838 147.12 270.673 147.376C270.508 147.632 270.273 147.831 269.999 147.949C269.724 148.067 269.422 148.097 269.131 148.037C268.84 147.977 268.572 147.829 268.362 147.612C268.152 147.394 268.009 147.117 267.951 146.815C267.893 146.514 267.923 146.201 268.036 145.917C268.15 145.632 268.342 145.389 268.59 145.219C268.837 145.048 269.127 144.956 269.424 144.956C269.823 144.956 270.205 145.12 270.486 145.412C270.768 145.704 270.926 146.099 270.926 146.512Z",
    fill: "#C5E0FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M263.097 144.773H259.738V148.251H263.097V144.773Z",
    fill: "#DCEAF8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M275.464 124.065H230.892C229.992 124.065 229.262 124.821 229.262 125.753V136.92C229.262 137.852 229.992 138.608 230.892 138.608H275.464C276.365 138.608 277.095 137.852 277.095 136.92V125.753C277.095 124.821 276.365 124.065 275.464 124.065Z",
    fill: "#C5E0FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M272.399 131.337C272.399 131.941 272.226 132.531 271.902 133.033C271.578 133.536 271.117 133.927 270.578 134.158C270.039 134.389 269.446 134.45 268.874 134.332C268.302 134.214 267.776 133.923 267.364 133.496C266.951 133.069 266.67 132.525 266.557 131.933C266.443 131.34 266.501 130.726 266.725 130.168C266.948 129.61 267.326 129.133 267.811 128.797C268.296 128.462 268.866 128.283 269.45 128.283C270.231 128.284 270.981 128.607 271.533 129.179C272.086 129.751 272.397 130.527 272.399 131.337Z",
    fill: "#DCEAF8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M270.926 131.337C270.926 131.644 270.838 131.945 270.673 132.201C270.508 132.457 270.273 132.656 269.999 132.774C269.724 132.891 269.422 132.922 269.131 132.862C268.84 132.802 268.572 132.654 268.362 132.437C268.152 132.219 268.009 131.942 267.951 131.64C267.893 131.338 267.923 131.026 268.036 130.741C268.15 130.457 268.342 130.214 268.59 130.043C268.837 129.872 269.127 129.781 269.424 129.781C269.823 129.781 270.205 129.945 270.486 130.237C270.768 130.529 270.926 130.924 270.926 131.337Z",
    fill: "#C5E0FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M263.097 129.598H259.738V133.076H263.097V129.598Z",
    fill: "#DCEAF8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M275.464 108.89H230.892C229.992 108.89 229.262 109.646 229.262 110.578V121.745C229.262 122.677 229.992 123.433 230.892 123.433H275.464C276.365 123.433 277.095 122.677 277.095 121.745V110.578C277.095 109.646 276.365 108.89 275.464 108.89Z",
    fill: "#C5E0FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M272.399 116.161C272.399 116.765 272.226 117.356 271.902 117.858C271.578 118.36 271.117 118.752 270.578 118.983C270.039 119.214 269.446 119.275 268.874 119.157C268.302 119.039 267.776 118.748 267.364 118.321C266.951 117.894 266.67 117.35 266.557 116.757C266.443 116.165 266.501 115.551 266.725 114.993C266.948 114.435 267.326 113.958 267.811 113.622C268.296 113.287 268.866 113.107 269.45 113.107C270.231 113.109 270.981 113.431 271.533 114.004C272.086 114.576 272.397 115.352 272.399 116.161Z",
    fill: "#DCEAF8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M270.926 116.161C270.926 116.469 270.838 116.77 270.673 117.026C270.508 117.281 270.273 117.481 269.999 117.598C269.724 117.716 269.422 117.747 269.131 117.687C268.84 117.627 268.572 117.479 268.362 117.261C268.152 117.044 268.009 116.767 267.951 116.465C267.893 116.163 267.923 115.85 268.036 115.566C268.15 115.282 268.342 115.039 268.59 114.868C268.837 114.697 269.127 114.606 269.424 114.606C269.823 114.606 270.205 114.77 270.486 115.062C270.768 115.353 270.926 115.749 270.926 116.161Z",
    fill: "#C5E0FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M263.097 114.423H259.738V117.9H263.097V114.423Z",
    fill: "#DCEAF8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M153.321 228.015C218.712 228.015 271.722 224.811 271.722 220.858C271.722 216.905 218.712 213.7 153.321 213.7C87.9298 213.7 34.9199 216.905 34.9199 220.858C34.9199 224.811 87.9298 228.015 153.321 228.015Z",
    fill: "#DCEAF8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8837 183.514C62.931 181.889 61.3678 183.299 61.3678 183.299C61.5937 180.194 58.8335 178.076 58.8335 178.076C58.8335 178.076 62.0395 178.076 62.4975 174.915C62.9555 171.753 61.38 173.227 59.9144 173.201C58.4488 173.176 56.916 177.627 58.8457 180.112C60.7754 182.597 60.2625 186.872 55.7924 190.969C54.7181 192.009 53.9156 193.314 53.4597 194.763C53.7956 191 53.9849 185.695 52.9162 182.155C51.0842 176.141 54.565 174.523 55.5665 171.513C56.568 168.503 52.9162 165.961 52.9162 165.961C52.9162 165.961 56.3481 164.343 54.6749 162.49C53.0017 160.637 49.5087 160.865 49.5087 163.28C49.5087 165.696 51.8598 166.625 51.8598 166.625C51.8598 166.625 54.5406 169.515 54.5406 171.02C54.5406 172.525 51.8598 175.762 51.8598 175.762C51.8598 175.762 53.0811 172.993 50.6385 172.872C48.1958 172.752 47.402 176.11 48.4034 177.615C49.4049 179.12 51.0842 177.842 51.0842 177.842C51.1892 179.597 51.4467 181.339 51.8537 183.046C52.104 183.912 51.988 187.308 51.7743 190.836C51.3111 189.561 50.5667 188.416 49.6003 187.491C45.1303 183.394 44.6173 179.132 46.547 176.641C48.4767 174.15 46.9501 169.686 45.4845 169.724C44.0189 169.762 42.4312 168.276 42.9014 171.443C43.3716 174.611 46.5654 174.605 46.5654 174.605C46.5654 174.605 43.8113 176.729 44.0311 179.828C44.0311 179.828 42.4678 178.424 41.5213 180.043C39.8237 182.932 43.7563 184.728 44.4158 183.305C44.4158 183.305 52.7452 189.407 50.7362 198.202L51.2003 198.917C51.1453 199.625 51.1026 200.049 51.1026 200.049L51.756 199.758L52.501 200.896C52.4726 202.164 52.5359 203.432 52.6903 204.69L54.681 201.642C52.6597 192.885 60.9891 186.77 60.9891 186.77C61.6487 188.193 65.5813 186.404 63.8837 183.514Z",
    fill: "url(#paint0_linear_1604_25275)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.8837 183.514C62.931 181.889 61.3678 183.299 61.3678 183.299C61.5937 180.194 58.8335 178.076 58.8335 178.076C58.8335 178.076 62.0395 178.076 62.4975 174.915C62.9555 171.753 61.38 173.227 59.9144 173.201C58.4488 173.176 56.916 177.627 58.8457 180.112C60.7754 182.597 60.2625 186.872 55.7924 190.969C54.7181 192.009 53.9156 193.314 53.4597 194.763C53.7956 191 53.9849 185.695 52.9162 182.155C51.0842 176.141 54.565 174.523 55.5665 171.513C56.568 168.503 52.9162 165.961 52.9162 165.961C52.9162 165.961 56.3481 164.343 54.6749 162.49C53.0017 160.637 49.5087 160.865 49.5087 163.28C49.5087 165.696 51.8598 166.625 51.8598 166.625C51.8598 166.625 54.5406 169.515 54.5406 171.02C54.5406 172.525 51.8598 175.762 51.8598 175.762C51.8598 175.762 53.0811 172.993 50.6385 172.872C48.1958 172.752 47.402 176.11 48.4034 177.615C49.4049 179.12 51.0842 177.842 51.0842 177.842C51.1892 179.597 51.4467 181.339 51.8537 183.046C52.104 183.912 51.988 187.308 51.7743 190.836C51.3111 189.561 50.5667 188.416 49.6003 187.491C45.1303 183.394 44.6173 179.132 46.547 176.641C48.4767 174.15 46.9501 169.686 45.4845 169.724C44.0189 169.762 42.4312 168.276 42.9014 171.443C43.3716 174.611 46.5654 174.605 46.5654 174.605C46.5654 174.605 43.8113 176.729 44.0311 179.828C44.0311 179.828 42.4678 178.424 41.5213 180.043C39.8237 182.932 43.7563 184.728 44.4158 183.305C44.4158 183.305 52.7452 189.407 50.7362 198.202L51.2003 198.917C51.1453 199.625 51.1026 200.049 51.1026 200.049L51.756 199.758L52.501 200.896C52.4726 202.164 52.5359 203.432 52.6903 204.69L54.681 201.642C52.6597 192.885 60.9891 186.77 60.9891 186.77C61.6487 188.193 65.5813 186.404 63.8837 183.514Z",
    fill: "url(#paint1_linear_1604_25275)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8837 183.514C62.931 181.889 61.3678 183.299 61.3678 183.299C61.5937 180.194 58.8335 178.076 58.8335 178.076C58.8335 178.076 62.0395 178.076 62.4975 174.915C62.9555 171.753 61.38 173.227 59.9144 173.201C58.4488 173.176 56.916 177.627 58.8457 180.112C60.7754 182.597 60.2625 186.872 55.7924 190.969C54.7181 192.009 53.9156 193.314 53.4597 194.763C53.7956 191 53.9849 185.695 52.9162 182.155C51.0842 176.141 54.565 174.523 55.5665 171.513C56.568 168.503 52.9162 165.961 52.9162 165.961C52.9162 165.961 56.3481 164.343 54.6749 162.49C53.0017 160.637 49.5087 160.865 49.5087 163.28C49.5087 165.696 51.8598 166.625 51.8598 166.625C51.8598 166.625 54.5406 169.515 54.5406 171.02C54.5406 172.525 51.8598 175.762 51.8598 175.762C51.8598 175.762 53.0811 172.993 50.6385 172.872C48.1958 172.752 47.402 176.11 48.4034 177.615C49.4049 179.12 51.0842 177.842 51.0842 177.842C51.1892 179.597 51.4467 181.339 51.8537 183.046C52.104 183.912 51.988 187.308 51.7743 190.836C51.3111 189.561 50.5667 188.416 49.6003 187.491C45.1303 183.394 44.6173 179.132 46.547 176.641C48.4767 174.15 46.9501 169.686 45.4845 169.724C44.0189 169.762 42.4312 168.276 42.9014 171.443C43.3716 174.611 46.5654 174.605 46.5654 174.605C46.5654 174.605 43.8113 176.729 44.0311 179.828C44.0311 179.828 42.4678 178.424 41.5213 180.043C39.8237 182.932 43.7563 184.728 44.4158 183.305C44.4158 183.305 52.7452 189.407 50.7362 198.202L51.2003 198.917C51.1453 199.625 51.1026 200.049 51.1026 200.049L51.756 199.758L52.501 200.896C52.4726 202.164 52.5359 203.432 52.6903 204.69L54.681 201.642C52.6597 192.885 60.9891 186.77 60.9891 186.77C61.6487 188.193 65.5813 186.404 63.8837 183.514Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.8837 183.514C62.931 181.889 61.3678 183.299 61.3678 183.299C61.5937 180.194 58.8335 178.076 58.8335 178.076C58.8335 178.076 62.0395 178.076 62.4975 174.915C62.9555 171.753 61.38 173.227 59.9144 173.201C58.4488 173.176 56.916 177.627 58.8457 180.112C60.7754 182.597 60.2625 186.872 55.7924 190.969C54.7181 192.009 53.9156 193.314 53.4597 194.763C53.7956 191 53.9849 185.695 52.9162 182.155C51.0842 176.141 54.565 174.523 55.5665 171.513C56.568 168.503 52.9162 165.961 52.9162 165.961C52.9162 165.961 56.3481 164.343 54.6749 162.49C53.0017 160.637 49.5087 160.865 49.5087 163.28C49.5087 165.696 51.8598 166.625 51.8598 166.625C51.8598 166.625 54.5406 169.515 54.5406 171.02C54.5406 172.525 51.8598 175.762 51.8598 175.762C51.8598 175.762 53.0811 172.993 50.6385 172.872C48.1958 172.752 47.402 176.11 48.4034 177.615C49.4049 179.12 51.0842 177.842 51.0842 177.842C51.1892 179.597 51.4467 181.339 51.8537 183.046C52.104 183.912 51.988 187.308 51.7743 190.836C51.3111 189.561 50.5667 188.416 49.6003 187.491C45.1303 183.394 44.6173 179.132 46.547 176.641C48.4767 174.15 46.9501 169.686 45.4845 169.724C44.0189 169.762 42.4312 168.276 42.9014 171.443C43.3716 174.611 46.5654 174.605 46.5654 174.605C46.5654 174.605 43.8113 176.729 44.0311 179.828C44.0311 179.828 42.4678 178.424 41.5213 180.043C39.8237 182.932 43.7563 184.728 44.4158 183.305C44.4158 183.305 52.7452 189.407 50.7362 198.202L51.2003 198.917C51.1453 199.625 51.1026 200.049 51.1026 200.049L51.756 199.758L52.501 200.896C52.4726 202.164 52.5359 203.432 52.6903 204.69L54.681 201.642C52.6597 192.885 60.9891 186.77 60.9891 186.77C61.6487 188.193 65.5813 186.404 63.8837 183.514Z",
    fill: "#DCEAF8"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2524 221.009H43.1693L41.1113 199.372H64.3103L62.2524 221.009Z",
    fill: "url(#paint2_linear_1604_25275)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.2524 221.009H43.1693L41.1113 199.372H64.3103L62.2524 221.009Z",
    fill: "#DCEAF8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3304 196.982H40.0918V201.756H65.3304V196.982Z",
    fill: "url(#paint3_linear_1604_25275)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M65.3304 196.982H40.0918V201.756H65.3304V196.982Z",
    fill: "#DCEAF8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M237.512 196.312L236.657 195.085C236.507 194.866 236.308 194.686 236.078 194.562C235.847 194.438 235.591 194.372 235.332 194.37H229.335C229.084 194.367 228.837 194.431 228.618 194.557C228.399 194.682 228.214 194.864 228.083 195.085L227.369 196.312C227.242 196.53 227.063 196.711 226.849 196.838C226.635 196.964 226.394 197.031 226.147 197.032H222.569C222.369 197.031 222.17 197.073 221.987 197.154C221.803 197.236 221.637 197.357 221.501 197.508C221.364 197.66 221.259 197.839 221.193 198.035C221.127 198.23 221.1 198.438 221.116 198.645L222.276 219.391C222.302 219.823 222.484 220.23 222.786 220.529C223.088 220.829 223.488 221.001 223.906 221.009H252.247C252.448 221.011 252.647 220.969 252.832 220.887C253.016 220.805 253.182 220.683 253.32 220.531C253.457 220.379 253.562 220.199 253.629 220.003C253.695 219.807 253.722 219.598 253.706 219.391L252.546 198.645C252.52 198.212 252.337 197.805 252.033 197.506C251.73 197.207 251.329 197.038 250.91 197.032H238.812C238.556 197.026 238.305 196.957 238.08 196.832C237.854 196.707 237.659 196.528 237.512 196.312Z",
    fill: "url(#paint4_linear_1604_25275)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M237.512 196.312L236.657 195.085C236.507 194.866 236.308 194.686 236.078 194.562C235.847 194.438 235.591 194.372 235.332 194.37H229.335C229.084 194.367 228.837 194.431 228.618 194.557C228.399 194.682 228.214 194.864 228.083 195.085L227.369 196.312C227.242 196.53 227.063 196.711 226.849 196.838C226.635 196.964 226.394 197.031 226.147 197.032H222.569C222.369 197.031 222.17 197.073 221.987 197.154C221.803 197.236 221.637 197.357 221.501 197.508C221.364 197.66 221.259 197.839 221.193 198.035C221.127 198.23 221.1 198.438 221.116 198.645L222.276 219.391C222.302 219.823 222.484 220.23 222.786 220.529C223.088 220.829 223.488 221.001 223.906 221.009H252.247C252.448 221.011 252.647 220.969 252.832 220.887C253.016 220.805 253.182 220.683 253.32 220.531C253.457 220.379 253.562 220.199 253.629 220.003C253.695 219.807 253.722 219.598 253.706 219.391L252.546 198.645C252.52 198.212 252.337 197.805 252.033 197.506C251.73 197.207 251.329 197.038 250.91 197.032H238.812C238.556 197.026 238.305 196.957 238.08 196.832C237.854 196.707 237.659 196.528 237.512 196.312Z",
    fill: "#DCEAF8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M253.756 199.012H227.76C227.228 199.019 226.717 199.228 226.323 199.598C225.93 199.968 225.68 200.475 225.622 201.022L224.059 218.992C224.032 219.25 224.059 219.511 224.137 219.757C224.215 220.003 224.343 220.23 224.512 220.421C224.682 220.611 224.888 220.763 225.119 220.864C225.349 220.966 225.598 221.015 225.848 221.009H251.844C252.377 221.002 252.888 220.792 253.282 220.42C253.676 220.049 253.925 219.541 253.981 218.992L255.545 201.022C255.572 200.765 255.545 200.504 255.467 200.258C255.389 200.012 255.261 199.786 255.091 199.596C254.922 199.405 254.715 199.255 254.485 199.154C254.254 199.053 254.006 199.005 253.756 199.012Z",
    fill: "url(#paint5_linear_1604_25275)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M253.756 199.012H227.76C227.228 199.019 226.717 199.228 226.323 199.598C225.93 199.968 225.68 200.475 225.622 201.022L224.059 218.992C224.032 219.25 224.059 219.511 224.137 219.757C224.215 220.003 224.343 220.23 224.512 220.421C224.682 220.611 224.888 220.763 225.119 220.864C225.349 220.966 225.598 221.015 225.848 221.009H251.844C252.377 221.002 252.888 220.792 253.282 220.42C253.676 220.049 253.925 219.541 253.981 218.992L255.545 201.022C255.572 200.765 255.545 200.504 255.467 200.258C255.389 200.012 255.261 199.786 255.091 199.596C254.922 199.405 254.715 199.255 254.485 199.154C254.254 199.053 254.006 199.005 253.756 199.012Z",
    fill: "#DCEAF8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M178.283 189.515H141.18V216.343H178.283V189.515Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M178.687 212.018H151.146C150.59 212.018 150.139 212.485 150.139 213.061V219.96C150.139 220.536 150.59 221.003 151.146 221.003H178.687C179.244 221.003 179.695 220.536 179.695 219.96V213.061C179.695 212.485 179.244 212.018 178.687 212.018Z",
    fill: "url(#paint6_linear_1604_25275)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.687 212.018H151.146C150.59 212.018 150.139 212.485 150.139 213.061V219.96C150.139 220.536 150.59 221.003 151.146 221.003H178.687C179.244 221.003 179.695 220.536 179.695 219.96V213.061C179.695 212.485 179.244 212.018 178.687 212.018Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M168.617 212.018H141.076C140.519 212.018 140.068 212.485 140.068 213.061V219.96C140.068 220.536 140.519 221.003 141.076 221.003H168.617C169.173 221.003 169.624 220.536 169.624 219.96V213.061C169.624 212.485 169.173 212.018 168.617 212.018Z",
    fill: "url(#paint7_linear_1604_25275)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.711 216.514C166.711 216.889 166.603 217.256 166.402 217.568C166.201 217.88 165.915 218.123 165.58 218.266C165.245 218.41 164.877 218.447 164.521 218.374C164.166 218.301 163.84 218.12 163.583 217.855C163.327 217.59 163.153 217.252 163.082 216.884C163.011 216.516 163.048 216.134 163.186 215.788C163.325 215.441 163.56 215.145 163.861 214.937C164.162 214.728 164.517 214.617 164.879 214.617C165.365 214.617 165.831 214.817 166.174 215.172C166.518 215.528 166.711 216.011 166.711 216.514Z",
    fill: "#DCEAF8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M164.891 217.475C165.404 217.475 165.819 217.044 165.819 216.514C165.819 215.983 165.404 215.553 164.891 215.553C164.378 215.553 163.963 215.983 163.963 216.514C163.963 217.044 164.378 217.475 164.891 217.475Z",
    fill: "url(#paint8_linear_1604_25275)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M160.982 215.439H158.906V217.589H160.982V215.439Z",
    fill: "#DCEAF8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M178.687 202.641H151.146C150.59 202.641 150.139 203.108 150.139 203.684V210.583C150.139 211.159 150.59 211.626 151.146 211.626H178.687C179.244 211.626 179.695 211.159 179.695 210.583V203.684C179.695 203.108 179.244 202.641 178.687 202.641Z",
    fill: "url(#paint9_linear_1604_25275)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.687 202.641H151.146C150.59 202.641 150.139 203.108 150.139 203.684V210.583C150.139 211.159 150.59 211.626 151.146 211.626H178.687C179.244 211.626 179.695 211.159 179.695 210.583V203.684C179.695 203.108 179.244 202.641 178.687 202.641Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M168.617 202.641H141.076C140.519 202.641 140.068 203.108 140.068 203.684V210.583C140.068 211.159 140.519 211.626 141.076 211.626H168.617C169.173 211.626 169.624 211.159 169.624 210.583V203.684C169.624 203.108 169.173 202.641 168.617 202.641Z",
    fill: "url(#paint10_linear_1604_25275)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.711 207.13C166.711 207.505 166.603 207.872 166.402 208.184C166.201 208.496 165.915 208.739 165.58 208.883C165.245 209.026 164.877 209.064 164.521 208.991C164.166 208.918 163.84 208.737 163.583 208.472C163.327 208.206 163.153 207.868 163.082 207.5C163.011 207.132 163.048 206.751 163.186 206.404C163.325 206.058 163.56 205.762 163.861 205.553C164.162 205.345 164.517 205.233 164.879 205.233C165.365 205.233 165.831 205.433 166.174 205.789C166.518 206.145 166.711 206.627 166.711 207.13Z",
    fill: "#DCEAF8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M165.813 207.13C165.812 207.322 165.756 207.508 165.651 207.666C165.547 207.824 165.399 207.946 165.227 208.017C165.055 208.087 164.867 208.103 164.687 208.062C164.506 208.021 164.341 207.925 164.214 207.787C164.086 207.648 164.001 207.473 163.97 207.285C163.939 207.096 163.963 206.902 164.039 206.728C164.115 206.553 164.24 206.406 164.397 206.306C164.554 206.205 164.737 206.155 164.922 206.163C165.163 206.173 165.39 206.279 165.557 206.46C165.723 206.64 165.815 206.881 165.813 207.13Z",
    fill: "url(#paint11_linear_1604_25275)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M160.982 206.055H158.906V208.205H160.982V206.055Z",
    fill: "#DCEAF8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M178.687 193.258H151.146C150.59 193.258 150.139 193.725 150.139 194.301V201.199C150.139 201.776 150.59 202.243 151.146 202.243H178.687C179.244 202.243 179.695 201.776 179.695 201.199V194.301C179.695 193.725 179.244 193.258 178.687 193.258Z",
    fill: "url(#paint12_linear_1604_25275)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.687 193.258H151.146C150.59 193.258 150.139 193.725 150.139 194.301V201.199C150.139 201.776 150.59 202.243 151.146 202.243H178.687C179.244 202.243 179.695 201.776 179.695 201.199V194.301C179.695 193.725 179.244 193.258 178.687 193.258Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M168.617 193.258H141.076C140.519 193.258 140.068 193.725 140.068 194.301V201.199C140.068 201.776 140.519 202.243 141.076 202.243H168.617C169.173 202.243 169.624 201.776 169.624 201.199V194.301C169.624 193.725 169.173 193.258 168.617 193.258Z",
    fill: "url(#paint13_linear_1604_25275)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.711 197.747C166.711 198.122 166.603 198.489 166.402 198.801C166.201 199.113 165.915 199.356 165.58 199.499C165.245 199.643 164.877 199.681 164.521 199.607C164.166 199.534 163.84 199.354 163.583 199.088C163.327 198.823 163.153 198.485 163.082 198.117C163.011 197.749 163.048 197.368 163.186 197.021C163.325 196.674 163.56 196.378 163.861 196.17C164.162 195.961 164.517 195.85 164.879 195.85C165.365 195.85 165.831 196.05 166.174 196.406C166.518 196.761 166.711 197.244 166.711 197.747Z",
    fill: "#DCEAF8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M165.813 197.747C165.813 197.937 165.759 198.124 165.657 198.282C165.554 198.44 165.409 198.563 165.239 198.636C165.069 198.708 164.882 198.727 164.702 198.689C164.522 198.652 164.356 198.56 164.227 198.424C164.097 198.289 164.009 198.118 163.974 197.931C163.939 197.744 163.958 197.55 164.029 197.375C164.101 197.199 164.221 197.05 164.374 196.945C164.527 196.84 164.708 196.785 164.891 196.786C165.136 196.788 165.371 196.89 165.544 197.07C165.716 197.25 165.813 197.493 165.813 197.747Z",
    fill: "url(#paint14_linear_1604_25275)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M160.982 196.672H158.906V198.822H160.982V196.672Z",
    fill: "#DCEAF8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M178.687 183.874H151.146C150.59 183.874 150.139 184.341 150.139 184.918V191.816C150.139 192.392 150.59 192.859 151.146 192.859H178.687C179.244 192.859 179.695 192.392 179.695 191.816V184.918C179.695 184.341 179.244 183.874 178.687 183.874Z",
    fill: "url(#paint15_linear_1604_25275)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.687 183.874H151.146C150.59 183.874 150.139 184.341 150.139 184.918V191.816C150.139 192.392 150.59 192.859 151.146 192.859H178.687C179.244 192.859 179.695 192.392 179.695 191.816V184.918C179.695 184.341 179.244 183.874 178.687 183.874Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M168.617 183.874H141.076C140.519 183.874 140.068 184.341 140.068 184.918V191.816C140.068 192.392 140.519 192.859 141.076 192.859H168.617C169.173 192.859 169.624 192.392 169.624 191.816V184.918C169.624 184.341 169.173 183.874 168.617 183.874Z",
    fill: "url(#paint16_linear_1604_25275)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.711 188.364C166.711 188.739 166.603 189.106 166.402 189.418C166.201 189.73 165.915 189.973 165.58 190.116C165.245 190.26 164.877 190.297 164.521 190.224C164.166 190.151 163.84 189.97 163.583 189.705C163.327 189.44 163.153 189.102 163.082 188.734C163.011 188.366 163.048 187.984 163.186 187.638C163.325 187.291 163.56 186.995 163.861 186.786C164.162 186.578 164.517 186.467 164.879 186.467C165.365 186.467 165.831 186.667 166.174 187.022C166.518 187.378 166.711 187.861 166.711 188.364Z",
    fill: "#DCEAF8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M165.813 188.364C165.813 188.554 165.759 188.74 165.657 188.898C165.554 189.056 165.409 189.18 165.239 189.252C165.069 189.325 164.882 189.343 164.702 189.306C164.522 189.268 164.356 189.176 164.227 189.041C164.097 188.906 164.009 188.734 163.974 188.547C163.939 188.36 163.958 188.167 164.029 187.992C164.101 187.816 164.221 187.666 164.374 187.562C164.527 187.457 164.708 187.401 164.891 187.403C165.136 187.404 165.371 187.506 165.544 187.686C165.716 187.866 165.813 188.11 165.813 188.364Z",
    fill: "url(#paint17_linear_1604_25275)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M160.982 187.289H158.906V189.439H160.982V187.289Z",
    fill: "#DCEAF8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M211.516 203.836H174.412V216.337H211.516V203.836Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M211.912 212.018H184.371C183.814 212.018 183.363 212.485 183.363 213.061V219.96C183.363 220.536 183.814 221.003 184.371 221.003H211.912C212.468 221.003 212.919 220.536 212.919 219.96V213.061C212.919 212.485 212.468 212.018 211.912 212.018Z",
    fill: "url(#paint18_linear_1604_25275)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.912 212.018H184.371C183.814 212.018 183.363 212.485 183.363 213.061V219.96C183.363 220.536 183.814 221.003 184.371 221.003H211.912C212.468 221.003 212.919 220.536 212.919 219.96V213.061C212.919 212.485 212.468 212.018 211.912 212.018Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M201.849 212.018H174.308C173.752 212.018 173.301 212.485 173.301 213.061V219.96C173.301 220.536 173.752 221.003 174.308 221.003H201.849C202.406 221.003 202.857 220.536 202.857 219.96V213.061C202.857 212.485 202.406 212.018 201.849 212.018Z",
    fill: "url(#paint19_linear_1604_25275)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M199.937 216.514C199.937 216.889 199.83 217.256 199.629 217.568C199.427 217.88 199.141 218.123 198.806 218.266C198.472 218.41 198.103 218.447 197.748 218.374C197.393 218.301 197.066 218.12 196.81 217.855C196.554 217.59 196.379 217.252 196.309 216.884C196.238 216.516 196.274 216.134 196.413 215.788C196.552 215.441 196.786 215.145 197.088 214.937C197.389 214.728 197.743 214.617 198.105 214.617C198.591 214.617 199.057 214.817 199.401 215.172C199.744 215.528 199.937 216.011 199.937 216.514Z",
    fill: "#DCEAF8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M199.046 216.514C199.046 216.704 198.991 216.89 198.889 217.048C198.787 217.206 198.642 217.329 198.473 217.402C198.303 217.474 198.117 217.493 197.937 217.456C197.757 217.419 197.591 217.328 197.461 217.193C197.332 217.059 197.243 216.888 197.207 216.701C197.171 216.515 197.19 216.322 197.26 216.146C197.33 215.97 197.449 215.82 197.602 215.715C197.755 215.609 197.934 215.553 198.118 215.553C198.364 215.553 198.6 215.654 198.774 215.834C198.948 216.014 199.046 216.259 199.046 216.514Z",
    fill: "url(#paint20_linear_1604_25275)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M194.209 215.439H192.133V217.589H194.209V215.439Z",
    fill: "#DCEAF8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M211.912 202.641H184.371C183.814 202.641 183.363 203.108 183.363 203.684V210.583C183.363 211.159 183.814 211.626 184.371 211.626H211.912C212.468 211.626 212.919 211.159 212.919 210.583V203.684C212.919 203.108 212.468 202.641 211.912 202.641Z",
    fill: "url(#paint21_linear_1604_25275)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.912 202.641H184.371C183.814 202.641 183.363 203.108 183.363 203.684V210.583C183.363 211.159 183.814 211.626 184.371 211.626H211.912C212.468 211.626 212.919 211.159 212.919 210.583V203.684C212.919 203.108 212.468 202.641 211.912 202.641Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M201.849 202.641H174.308C173.752 202.641 173.301 203.108 173.301 203.684V210.583C173.301 211.159 173.752 211.626 174.308 211.626H201.849C202.406 211.626 202.857 211.159 202.857 210.583V203.684C202.857 203.108 202.406 202.641 201.849 202.641Z",
    fill: "url(#paint22_linear_1604_25275)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M199.937 207.13C199.937 207.505 199.83 207.872 199.629 208.184C199.427 208.496 199.141 208.739 198.806 208.883C198.472 209.026 198.103 209.064 197.748 208.991C197.393 208.918 197.066 208.737 196.81 208.472C196.554 208.206 196.379 207.868 196.309 207.5C196.238 207.132 196.274 206.751 196.413 206.404C196.552 206.058 196.786 205.762 197.088 205.553C197.389 205.345 197.743 205.233 198.105 205.233C198.591 205.233 199.057 205.433 199.401 205.789C199.744 206.145 199.937 206.627 199.937 207.13Z",
    fill: "#DCEAF8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M199.046 207.13C199.046 207.32 198.991 207.506 198.889 207.664C198.787 207.822 198.642 207.945 198.473 208.018C198.303 208.091 198.117 208.11 197.937 208.073C197.757 208.036 197.591 207.944 197.461 207.81C197.332 207.675 197.243 207.504 197.207 207.318C197.171 207.131 197.19 206.938 197.26 206.762C197.33 206.587 197.449 206.437 197.602 206.331C197.755 206.226 197.934 206.169 198.118 206.169C198.364 206.169 198.6 206.27 198.774 206.451C198.948 206.631 199.046 206.875 199.046 207.13Z",
    fill: "url(#paint23_linear_1604_25275)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M194.209 206.055H192.133V208.205H194.209V206.055Z",
    fill: "#DCEAF8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M104.065 210.014L100.218 210.722L98.6365 205.284L97.1953 200.289L101.635 198.683L102.923 204.683L104.065 210.014Z",
    fill: "#E4897B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.946 204.803L98.6526 205.391L97.1992 200.346L101.639 198.714L102.946 204.803Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3483 211.854H74.4401L73.7989 206.15L73.2188 200.94L77.8598 200.143L78.1224 206.34L78.3483 211.854Z",
    fill: "#E4897B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.1224 206.39L73.7989 206.194L73.2188 200.965L77.8598 200.156L78.1224 206.39Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6553 219.877C83.0357 219.355 82.3275 218.956 81.5669 218.701C81.5669 218.701 79.2952 216.368 78.2021 209.343L75.2282 208.54C74.7234 208.413 74.1928 208.449 73.7088 208.645C73.2247 208.841 72.8107 209.186 72.523 209.634C72.4382 209.757 72.3742 209.894 72.3337 210.039C72.1758 210.791 72.0697 211.554 72.0161 212.321C71.7169 214.699 71.9734 220.035 71.9734 220.035H72.5108L72.7245 215.192C72.8039 213.548 74.0191 215.477 74.3672 217.247C74.7153 219.017 75.4542 220.902 78.9349 220.99C82.9958 221.072 84.6812 220.908 83.6553 219.877Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M109.608 219.403C108.989 218.88 108.281 218.482 107.52 218.227C107.52 218.227 105.248 215.894 104.155 208.869L101.181 208.06C100.677 207.932 100.146 207.969 99.6619 208.164C99.1778 208.36 98.7638 208.705 98.4761 209.154C98.3914 209.276 98.3274 209.413 98.2868 209.558C98.129 210.31 98.0228 211.073 97.9693 211.841C97.67 214.218 97.9265 219.555 97.9265 219.555H98.4639L98.6776 214.712C98.757 213.068 99.9722 214.996 100.32 216.766C100.668 218.537 101.407 220.421 104.888 220.51C108.949 220.598 110.634 220.434 109.608 219.403Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M103.307 201.642L96.9747 202.799C90.5871 186.315 86.0438 172.556 82.8318 161.137C81.1036 154.972 79.6624 149.496 78.6243 144.634L78.8197 162.578V203.001H72.5788C56.9398 125.861 68.0233 108.283 68.0233 108.283L86.7583 105.052C87.501 108.644 88.0252 112.28 88.3277 115.94L89.1704 122.371L96.4983 161.491L103.307 201.642Z",
    fill: "url(#paint24_linear_1604_25275)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.307 201.642L96.9747 202.799C90.5872 186.315 86.0438 172.556 82.8318 161.137C81.1036 154.972 79.6624 149.496 78.6243 144.634L78.8197 162.578V203.001H72.5788C56.9398 125.861 68.0233 108.283 68.0233 108.283L86.7583 105.052C87.501 108.644 88.0252 112.28 88.3277 115.94L89.1704 122.371L96.4983 161.491L103.307 201.642Z",
    fill: "black"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M108.895 86.026L115.209 79.5639C115.209 79.5639 115.429 77.8314 116.039 77.3509C116.65 76.8703 120.986 75.239 121.535 75.6057C122.085 75.9725 122.805 79.5892 122.066 80.2531C121.328 80.917 117.383 81.7643 116.98 81.6948L110.146 90.098L108.895 86.026Z",
    fill: "#EEC1BB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2699 74.2336C88.9995 75.7259 98.6663 89.725 100.089 90.4205C101.512 91.116 112.406 81.973 112.406 81.973L114.238 85.2104C114.238 85.2104 105.304 98.28 100.254 97.6477C95.2039 97.0154 85.5371 85.9502 85.5371 85.9502L86.2699 74.2336Z",
    fill: "#263238"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M86.2699 74.2336C88.9995 75.7259 98.6663 89.725 100.089 90.4205C101.512 91.116 112.406 81.973 112.406 81.973L114.238 85.2104C114.238 85.2104 105.304 98.28 100.254 97.6477C95.2039 97.0154 85.5371 85.9502 85.5371 85.9502L86.2699 74.2336Z",
    fill: "#DCEAF8"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M111.801 82.3144L112.558 81.5746L114.543 85.0522L113.828 86.4749L111.801 82.3144Z",
    fill: "url(#paint25_linear_1604_25275)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.4209 90.0347C87.1615 87.8027 85.5371 85.9501 85.5371 85.9501L85.7081 83.1679L86.5569 80.468C87.7252 81.7185 88.5931 83.2359 89.0906 84.8978C89.5881 86.5596 89.7012 88.3192 89.4209 90.0347Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M82.8324 161.137C81.1042 154.972 79.7791 149.496 78.7227 144.634C78.8146 138.877 79.2223 133.131 79.944 127.423C79.944 127.423 82.6736 149.623 82.8324 161.137Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1857 103.857C87.949 89.9463 87.607 82.2828 87.2589 78.4574C86.8803 74.3791 86.2697 74.2336 86.2697 74.2336C86.2697 74.2336 81.9951 73.8037 78.2945 73.829C75.427 73.9327 72.5702 74.2454 69.7452 74.7648C67.0568 75.2274 64.4038 75.8888 61.8066 76.7439C62.2402 78.0085 62.631 79.273 63.028 80.3859C63.5165 81.8971 63.9501 83.2945 64.3409 84.6033C65.0737 87.044 65.6477 89.1559 66.1057 91.0528C67.2717 95.8135 67.9512 100.688 68.1331 105.596C68.1331 105.596 63.4371 118.305 62.5211 127.631L78.0929 129.37L80.2302 120.044L82.3676 129.686L91.0328 126.493L87.1857 103.857Z",
    fill: "#263238"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.1857 103.857C87.949 89.9463 87.607 82.2828 87.2589 78.4574C86.8803 74.3791 86.2697 74.2336 86.2697 74.2336C86.2697 74.2336 81.9951 73.8037 78.2945 73.829C75.427 73.9327 72.5702 74.2454 69.7452 74.7648C67.0568 75.2274 64.4038 75.8888 61.8066 76.7439C62.2402 78.0085 62.631 79.273 63.028 80.3859C63.5165 81.8971 63.9501 83.2945 64.3409 84.6033C65.0737 87.044 65.6477 89.1559 66.1057 91.0528C67.2717 95.8135 67.9512 100.688 68.1331 105.596C68.1331 105.596 63.4371 118.305 62.5211 127.631L78.0929 129.37L80.2302 120.044L82.3676 129.686L91.0328 126.493L87.1857 103.857Z",
    fill: "#DCEAF8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.8207 94.4545C66.6131 93.3922 66.3689 92.2604 66.0696 91.0464C65.8803 90.275 65.6727 89.4656 65.459 88.6057C66.0696 86.4496 66.6803 88.1378 66.6803 88.1378C67.059 90.2214 67.1064 92.3551 66.8207 94.4545Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M71.998 78.647L79.7351 92.9813L81.5671 77.5974L78.0558 82.1563L71.998 78.647Z",
    fill: "url(#paint26_linear_1604_25275)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7969 73.5381C68.3406 74.379 67.2963 77.256 67.6749 79.8611L70.197 78.9948C73.1058 80.0826 75.8351 81.6288 78.2882 83.579C78.2882 83.579 80.1935 79.9433 82.0254 78.7545L84.6208 79.0707C84.6208 79.0707 80.5782 71.4072 71.7969 73.5381Z",
    fill: "url(#paint27_linear_1604_25275)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.7969 73.5381C68.3406 74.379 67.2963 77.256 67.6749 79.8611L70.197 78.9948C73.1058 80.0826 75.8351 81.6288 78.2882 83.579C78.2882 83.579 80.1935 79.9433 82.0254 78.7545L84.6208 79.0707C84.6208 79.0707 80.5782 71.4072 71.7969 73.5381Z",
    fill: "#DCEAF8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0747 74.6762C77.8789 74.5731 77.6745 74.4885 77.4641 74.4233C77.0244 74.0629 76.487 73.1966 76.5176 71.0847C76.5299 70.2581 76.6034 69.4337 76.7374 68.6188L71.0766 67.5249C71.0766 67.5249 73.0063 71.4704 71.3941 74.398C70.8384 74.6509 70.5087 75.0303 70.5697 75.4919C70.9911 78.881 78.0259 82.1563 78.0259 82.1563C78.0259 82.1563 81.4944 76.6237 78.0747 74.6762Z",
    fill: "#EEC1BB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.7682 68.6188C76.6342 69.4337 76.5607 70.2581 76.5484 71.0847C72.7196 71.0847 71.1074 67.5249 71.1074 67.5249L76.7682 68.6188Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2383 49.2767C74.2383 49.2767 80.8823 48.4042 82.1036 53.9368C82.4581 55.5103 82.3736 57.1556 81.8601 58.6814C81.3466 60.2071 80.4251 61.5504 79.203 62.555L74.2383 49.2767Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6337 52.2232C78.5556 51.945 80.2838 54.5817 80.925 59.8108C81.7249 66.3488 80.5647 71.091 74.336 70.0351C65.8783 68.6124 65.4631 52.6848 73.6337 52.2232Z",
    fill: "#EEC1BB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7266 59.7097C78.1621 60.4492 78.6807 61.1326 79.2715 61.7457C79.1371 61.961 78.9481 62.1339 78.7252 62.2454C78.5022 62.357 78.2539 62.4028 78.0075 62.378L77.7266 59.7097Z",
    fill: "#D4827D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M74.691 59.4695C74.7276 59.8868 74.5322 60.2472 74.2635 60.2662C73.9948 60.2851 73.7506 59.969 73.72 59.5517C73.6895 59.1344 73.8788 58.7739 74.1475 58.755C74.4162 58.736 74.6604 59.0458 74.691 59.4695Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0371 58.7739L74.892 58.3502C74.892 58.3502 74.5073 59.1469 74.0371 58.7739Z",
    fill: "#263238"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7046 58.97C79.7413 59.3873 79.5459 59.7477 79.2772 59.7666C79.0085 59.7856 78.7642 59.4695 78.7337 59.0521C78.7032 58.6348 78.8925 58.2744 79.1612 58.2554C79.4298 58.2365 79.6741 58.5526 79.7046 58.97Z",
    fill: "#263238"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0508 58.2807L79.8996 57.8571C79.8996 57.8571 79.521 58.6537 79.0508 58.2807Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4598 55.9475C74.0681 55.9206 73.6757 55.987 73.3126 56.1416C72.9495 56.2961 72.6255 56.5347 72.3652 56.839",
    stroke: "#263238",
    strokeWidth: 0.686238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0254 55.5301C78.3571 55.4219 78.7084 55.3935 79.0523 55.4472C79.3963 55.5009 79.7239 55.6352 80.01 55.84",
    stroke: "#263238",
    strokeWidth: 0.686238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7115 61.1197C68.7115 61.1197 70.7878 56.8011 70.2687 53.589C70.2687 53.589 79.8072 48.91 80.827 59.1343C80.827 59.1343 81.3033 49.9786 72.8274 50.2504C64.3514 50.5223 65.072 63.3454 69.6458 66.9179C69.658 66.9179 67.423 63.8196 68.7115 61.1197Z",
    fill: "#263238"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0817 48.8784C75.0817 48.8784 79.1243 47.8541 80.2723 48.9606C81.4203 50.0672 73.2497 57.8887 68.9751 58.6791C68.9751 58.6791 67.5217 63.5794 68.6698 65.8746C68.6698 65.8746 63.8578 64.1358 63.6318 56.5482C63.4059 48.9606 71.1124 46.1153 75.0817 48.8784Z",
    fill: "#263238"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M69.573 62.1503C69.4913 61.5637 69.1883 61.0346 68.7304 60.679C68.2725 60.3234 67.6971 60.1704 67.1304 60.2534C65.6159 60.5064 65.0602 63.7943 68.8952 64.357C69.4509 64.4266 69.7318 63.8575 69.573 62.1503Z",
    fill: "#EEC1BB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4478 51.8818C67.4478 51.8818 65.7685 47.4558 61.2618 47.7719C56.7551 48.0881 56.0712 55.3595 58.4405 60.734C60.8099 66.1086 59.2039 67.8474 59.2039 67.8474C59.2039 67.8474 61.7198 67.5313 61.7198 62.7131C61.8588 63.7328 61.9099 64.7633 61.8725 65.7924C61.8725 65.7924 63.5518 63.3454 61.9518 58.6791C60.3519 54.0127 65.4631 56.1499 65.4631 56.1499L67.4478 51.8818Z",
    fill: "#263238"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8885 49.3527C79.8885 49.3527 77.7512 56.466 72.0293 58.6032",
    stroke: "#263238",
    strokeWidth: 0.686238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M74.166 64.2117C74.5373 64.5927 74.9778 64.8939 75.4619 65.0979C75.9461 65.3019 76.4645 65.4047 76.9873 65.4004",
    stroke: "#263238",
    strokeWidth: 0.686238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2194 60.1839C77.2016 60.4028 77.1227 60.6116 76.9924 60.7848C76.862 60.9581 76.6857 61.0883 76.4851 61.1596C76.2844 61.2309 76.0681 61.2402 75.8624 61.1864C75.6568 61.1326 75.4707 61.018 75.3268 60.8566C75.183 60.6952 75.0876 60.4939 75.0523 60.2773C75.0171 60.0607 75.0434 59.8382 75.1282 59.6368C75.2129 59.4355 75.3524 59.264 75.5297 59.1434C75.7069 59.0227 75.9142 58.958 76.1263 58.9573C76.2761 58.963 76.4232 58.9993 76.5593 59.0641C76.6955 59.1289 76.8179 59.221 76.9195 59.335C77.0211 59.4491 77.0999 59.5828 77.1513 59.7284C77.2028 59.8741 77.226 60.0289 77.2194 60.1839Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0734 59.9816C81.0568 60.2011 80.9787 60.4108 80.8486 60.5851C80.7186 60.7593 80.5423 60.8905 80.3414 60.9626C80.1404 61.0346 79.9235 61.0444 79.7173 60.9907C79.511 60.9371 79.3244 60.8222 79.1802 60.6604C79.036 60.4985 78.9406 60.2966 78.9055 60.0794C78.8705 59.8622 78.8975 59.6392 78.983 59.4376C79.0686 59.236 79.2091 59.0646 79.3874 58.9445C79.5656 58.8244 79.7738 58.7607 79.9865 58.7612C80.2861 58.776 80.5682 58.9123 80.7716 59.1407C80.975 59.369 81.0834 59.6711 81.0734 59.9816Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2188 60.1839C77.2188 60.1839 77.7867 58.9193 78.8981 59.9816",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0401 60.1839C75.0401 60.1839 68.9335 59.9816 68.2129 60.0259",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8844 89.7123L68.6035 105.855C68.6029 105.945 68.6208 106.034 68.6559 106.116C68.6911 106.198 68.7428 106.271 68.8075 106.331C68.8722 106.391 68.9485 106.436 69.0312 106.463C69.114 106.49 69.2013 106.498 69.2875 106.487L79.5527 105.64C79.7146 105.64 79.8699 105.573 79.9845 105.455C80.099 105.336 80.1633 105.175 80.1633 105.008L80.658 88.9978C80.6637 88.906 80.6501 88.814 80.6181 88.7283C80.586 88.6425 80.5363 88.565 80.4723 88.5012C80.4084 88.4374 80.3318 88.3888 80.2478 88.3588C80.1638 88.3288 80.0746 88.3181 79.9862 88.3275L69.5073 89.0294C69.4218 89.0273 69.3369 89.0439 69.2579 89.078C69.179 89.1121 69.1079 89.163 69.0492 89.2274C68.9905 89.2917 68.9454 89.3682 68.9171 89.4517C68.8887 89.5352 68.8776 89.624 68.8844 89.7123Z",
    fill: "url(#paint28_linear_1604_25275)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M68.8844 89.7123L68.6035 105.855C68.6029 105.945 68.6208 106.034 68.6559 106.116C68.6911 106.198 68.7428 106.271 68.8075 106.331C68.8722 106.391 68.9485 106.436 69.0312 106.463C69.114 106.49 69.2013 106.498 69.2875 106.487L79.5527 105.64C79.7146 105.64 79.8699 105.573 79.9845 105.455C80.099 105.336 80.1633 105.175 80.1633 105.008L80.658 88.9978C80.6637 88.906 80.6501 88.814 80.6181 88.7283C80.586 88.6425 80.5363 88.565 80.4723 88.5012C80.4084 88.4374 80.3318 88.3888 80.2478 88.3588C80.1638 88.3288 80.0746 88.3181 79.9862 88.3275L69.5073 89.0294C69.4218 89.0273 69.3369 89.0439 69.2579 89.078C69.179 89.1121 69.1079 89.163 69.0492 89.2274C68.9905 89.2917 68.9454 89.3682 68.9171 89.4517C68.8887 89.5352 68.8776 89.624 68.8844 89.7123Z",
    fill: "#DCEAF8"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1882 90.079L68.9073 106.222C68.9021 106.314 68.9167 106.407 68.9498 106.493C68.983 106.579 69.034 106.656 69.0993 106.719C69.1645 106.783 69.2424 106.83 69.3274 106.859C69.4124 106.888 69.5024 106.897 69.5912 106.886L79.8564 106.045C80.0183 106.045 80.1737 105.978 80.2882 105.859C80.4027 105.741 80.467 105.58 80.467 105.412L80.9617 89.4088C80.9684 89.3165 80.9555 89.2238 80.9239 89.1373C80.8922 89.0508 80.8426 88.9725 80.7785 88.9079C80.7145 88.8434 80.6375 88.7942 80.5531 88.7639C80.4687 88.7335 80.3789 88.7227 80.29 88.7322L69.7805 89.4404C69.6207 89.4454 69.4691 89.515 69.3584 89.6344C69.2476 89.7539 69.1865 89.9135 69.1882 90.079Z",
    fill: "url(#paint29_linear_1604_25275)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M69.1882 90.079L68.9073 106.222C68.9021 106.314 68.9167 106.407 68.9498 106.493C68.983 106.579 69.034 106.656 69.0993 106.719C69.1645 106.783 69.2424 106.83 69.3274 106.859C69.4124 106.888 69.5024 106.897 69.5912 106.886L79.8564 106.045C80.0183 106.045 80.1737 105.978 80.2882 105.859C80.4027 105.741 80.467 105.58 80.467 105.412L80.9617 89.4088C80.9684 89.3165 80.9555 89.2238 80.9239 89.1373C80.8922 89.0508 80.8426 88.9725 80.7785 88.9079C80.7145 88.8434 80.6375 88.7942 80.5531 88.7639C80.4687 88.7335 80.3789 88.7227 80.29 88.7322L69.7805 89.4404C69.6207 89.4454 69.4691 89.515 69.3584 89.6344C69.2476 89.7539 69.1865 89.9135 69.1882 90.079Z",
    fill: "#DCEAF8"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.2721 97.7741C76.2721 98.0867 76.1825 98.3924 76.0148 98.6523C75.847 98.9123 75.6086 99.1149 75.3296 99.2345C75.0507 99.3542 74.7437 99.3855 74.4476 99.3245C74.1514 99.2635 73.8794 99.1129 73.6659 98.8919C73.4524 98.6708 73.307 98.3891 73.2481 98.0825C73.1892 97.7759 73.2194 97.458 73.335 97.1692C73.4505 96.8803 73.6462 96.6335 73.8972 96.4598C74.1483 96.2861 74.4435 96.1934 74.7454 96.1934H74.8065C74.8628 96.553 75.0378 96.8813 75.3017 97.1223C75.5656 97.3632 75.9021 97.502 76.2537 97.5149C76.2662 97.6007 76.2723 97.6873 76.2721 97.7741Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9688 102.839L67.4799 97.9385C67.4799 97.9385 68.0539 96.2945 68.75 95.9594C69.4462 95.6243 74.02 95.0046 74.4597 95.4725C74.8994 95.9404 74.8689 99.652 74.0078 100.133C73.1468 100.613 69.1225 100.569 68.7378 100.404L60.3229 107.088L59.9688 102.839Z",
    fill: "#EEC1BB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8001 76.7438C61.8001 76.7438 66.7098 84.129 65.9953 90.452L59.4795 101.625L63.858 99.3042L65.8426 103.18C65.8426 103.18 60.8047 111.21 54.3927 109.314C47.9808 107.417 61.8001 76.7438 61.8001 76.7438Z",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61.8001 76.7438C61.8001 76.7438 66.7098 84.129 65.9953 90.452L59.4795 101.625L63.858 99.3042L65.8426 103.18C65.8426 103.18 60.8047 111.21 54.3927 109.314C47.9808 107.417 61.8001 76.7438 61.8001 76.7438Z",
    fill: "#DCEAF8"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4004 99.0956L65.8919 103.888L66.4537 102.516L64.469 98.6213L63.4004 99.0956Z",
    fill: "url(#paint30_linear_1604_25275)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M120.343 79.4755C119.785 79.4767 119.239 79.3065 118.774 78.9863C118.309 78.666 117.947 78.2102 117.732 77.6766C117.518 77.1429 117.461 76.5553 117.569 75.9883C117.677 75.4212 117.945 74.9001 118.34 74.4909C118.734 74.0817 119.237 73.8029 119.784 73.6897C120.332 73.5764 120.899 73.6339 121.415 73.8548C121.931 74.0757 122.372 74.4501 122.682 74.9307C122.993 75.4112 123.158 75.9762 123.158 76.5543C123.158 77.3279 122.862 78.07 122.334 78.6177C121.806 79.1653 121.09 79.4738 120.343 79.4755Z",
    fill: "url(#paint31_linear_1604_25275)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M121.631 92.3491H121.563C118.916 92.3094 116.324 91.553 114.046 90.155L115.579 87.3603C117.391 88.476 119.455 89.0779 121.563 89.1054L121.631 92.3491ZM129.142 90.0096L127.603 87.2907C129.42 86.1926 130.927 84.6208 131.975 82.7318L134.619 84.3062C133.306 86.6701 131.417 88.6365 129.142 90.0096ZM108.556 84.3189C107.234 81.9558 106.536 79.273 106.535 76.5416H109.588C109.586 78.7185 110.143 80.8569 111.201 82.7381L108.556 84.3189ZM133.593 76.4847C133.588 74.3093 133.027 72.1739 131.969 70.2945L134.607 68.7011C135.934 71.0636 136.637 73.7456 136.647 76.4784L133.593 76.4847ZM111.182 70.3704L108.544 68.7896C109.866 66.4293 111.761 64.4675 114.04 63.0989L115.573 65.8305C113.755 66.9249 112.242 68.4892 111.182 70.3704ZM127.536 65.7925C125.731 64.6765 123.677 64.0664 121.576 64.0221L121.563 60.7341C124.201 60.7785 126.782 61.5348 129.05 62.9282L127.536 65.7925Z",
    fill: "url(#paint32_linear_1604_25275)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.631 92.3491H121.563C118.916 92.3094 116.324 91.553 114.046 90.155L115.579 87.3603C117.391 88.476 119.455 89.0779 121.563 89.1054L121.631 92.3491ZM129.142 90.0096L127.603 87.2907C129.42 86.1926 130.927 84.6208 131.975 82.7318L134.619 84.3062C133.306 86.6701 131.417 88.6365 129.142 90.0096ZM108.556 84.3189C107.234 81.9558 106.536 79.273 106.535 76.5416H109.588C109.586 78.7185 110.143 80.8569 111.201 82.7381L108.556 84.3189ZM133.593 76.4847C133.588 74.3093 133.027 72.1739 131.969 70.2945L134.607 68.7011C135.934 71.0636 136.637 73.7456 136.647 76.4784L133.593 76.4847ZM111.182 70.3704L108.544 68.7896C109.866 66.4293 111.761 64.4675 114.04 63.0989L115.573 65.8305C113.755 66.9249 112.242 68.4892 111.182 70.3704ZM127.536 65.7925C125.731 64.6765 123.677 64.0664 121.576 64.0221L121.563 60.7341C124.201 60.7785 126.782 61.5348 129.05 62.9282L127.536 65.7925Z",
    fill: "#DCEAF8"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M124.619 80.4491C123.875 80.4503 123.147 80.223 122.528 79.7958C121.908 79.3685 121.425 78.7607 121.14 78.0491C120.854 77.3375 120.779 76.5541 120.923 75.7981C121.068 75.0422 121.425 74.3476 121.951 73.8022C122.477 73.2569 123.147 72.8853 123.877 72.7345C124.607 72.5837 125.364 72.6604 126.051 72.9551C126.739 73.2497 127.327 73.7489 127.741 74.3896C128.154 75.0302 128.375 75.7835 128.375 76.5541C128.375 77.5861 127.979 78.5758 127.275 79.3061C126.571 80.0363 125.616 80.4474 124.619 80.4491Z",
    fill: "url(#paint33_linear_1604_25275)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.619 80.4491C123.875 80.4503 123.147 80.223 122.528 79.7958C121.908 79.3685 121.425 78.7607 121.14 78.0491C120.854 77.3375 120.779 76.5541 120.923 75.7981C121.068 75.0422 121.425 74.3476 121.951 73.8022C122.477 73.2569 123.147 72.8853 123.877 72.7345C124.607 72.5837 125.364 72.6604 126.051 72.9551C126.739 73.2497 127.327 73.7489 127.741 74.3896C128.154 75.0302 128.375 75.7835 128.375 76.5541C128.375 77.5861 127.979 78.5758 127.275 79.3061C126.571 80.0363 125.616 80.4474 124.619 80.4491Z",
    fill: "#DCEAF8"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M131.864 78.0208C132.649 74.5779 130.59 71.1281 127.265 70.3155C123.94 69.5029 120.608 71.6352 119.823 75.0781C119.039 78.521 121.098 81.9708 124.423 82.7833C127.748 83.5959 131.08 81.4637 131.864 78.0208Z",
    stroke: "url(#paint34_linear_1604_25275)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M233.927 75.9092H131.336V77.1738H233.927V75.9092Z",
    fill: "url(#paint35_linear_1604_25275)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M126.45 70.8508H125.229V63.2632C125.228 63.18 125.243 63.0975 125.274 63.0205C125.304 62.9435 125.349 62.8734 125.406 62.8143L162.76 24.244C162.817 24.1854 162.884 24.1391 162.959 24.1076C163.033 24.0761 163.113 24.0602 163.193 24.0607H197.286V25.3253H163.444L126.45 63.5225V70.8508Z",
    fill: "url(#paint36_linear_1604_25275)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M214.996 134.713H169.196C169.116 134.714 169.036 134.698 168.962 134.666C168.887 134.635 168.82 134.588 168.762 134.53L125.406 89.6364C125.349 89.5774 125.304 89.5073 125.274 89.4302C125.243 89.3532 125.228 89.2707 125.229 89.1875V82.8645H126.45V88.9283L169.446 133.448H214.996V134.713Z",
    fill: "url(#paint37_linear_1604_25275)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M184.463 94.2459H159.933C159.773 94.2452 159.619 94.1793 159.505 94.0625L143.018 77.0979L143.879 76.2001L160.189 92.9813H184.463V94.2459Z",
    fill: "url(#paint38_linear_1604_25275)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M167.492 77.0412L166.625 76.1496L183.058 59.0206C183.175 58.9051 183.33 58.8396 183.491 58.8373H208.278V60.1019H183.748L167.492 77.0412Z",
    fill: "url(#paint39_linear_1604_25275)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M260.796 44.9265H163.841C163.761 44.9262 163.681 44.9092 163.606 44.8767C163.532 44.8441 163.464 44.7966 163.408 44.7368L153.674 34.5568L154.541 33.6653L164.098 43.6619H260.796V44.9265Z",
    fill: "url(#paint40_linear_1604_25275)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M174.307 25.1419L173.471 24.244L189.348 7.80423C189.405 7.74563 189.473 7.69926 189.547 7.66779C189.621 7.63633 189.701 7.62038 189.781 7.62086H240.643V8.88546H190.007L174.307 25.1419Z",
    fill: "url(#paint41_linear_1604_25275)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M184.237 165.696L159.603 140.195C159.494 140.082 159.431 139.931 159.426 139.771V124.596H160.647V139.512L185.074 164.804L184.237 165.696Z",
    fill: "url(#paint42_linear_1604_25275)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M178.686 134.327L177.818 133.448L194.013 116.572C194.13 116.457 194.285 116.391 194.447 116.389H255.91V117.654H194.703L178.686 134.327Z",
    fill: "url(#paint43_linear_1604_25275)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M235.758 152.417H208.382C208.302 152.418 208.222 152.402 208.148 152.37C208.073 152.339 208.005 152.293 207.948 152.234L190.746 134.422L191.613 133.531L208.632 151.153H235.758V152.417Z",
    fill: "url(#paint44_linear_1604_25275)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M240.643 11.1492C242.187 11.1492 243.439 9.85261 243.439 8.25323C243.439 6.65385 242.187 5.3573 240.643 5.3573C239.098 5.3573 237.846 6.65385 237.846 8.25323C237.846 9.85261 239.098 11.1492 240.643 11.1492Z",
    fill: "url(#paint45_linear_1604_25275)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M202.783 31.3828C201.505 31.3828 200.256 30.9904 199.194 30.2553C198.131 29.5203 197.303 28.4755 196.814 27.2531C196.325 26.0307 196.197 24.6856 196.446 23.3879C196.696 22.0902 197.311 20.8982 198.215 19.9627C199.118 19.0271 200.269 18.39 201.523 18.1318C202.776 17.8737 204.075 18.0062 205.255 18.5125C206.436 19.0189 207.445 19.8763 208.155 20.9764C208.865 22.0765 209.244 23.3699 209.244 24.693C209.244 26.4673 208.563 28.1688 207.352 29.4234C206.14 30.6779 204.497 31.3828 202.783 31.3828ZM202.783 19.2679C201.747 19.2679 200.734 19.5861 199.872 20.1822C199.011 20.7783 198.339 21.6256 197.942 22.6169C197.546 23.6082 197.442 24.699 197.644 25.7514C197.846 26.8038 198.345 27.7705 199.078 28.5292C199.811 29.2879 200.745 29.8046 201.761 30.0139C202.777 30.2232 203.831 30.1158 204.788 29.7052C205.745 29.2946 206.564 28.5992 207.14 27.7071C207.715 26.8149 208.023 25.766 208.023 24.693C208.021 23.2547 207.468 21.8758 206.486 20.8587C205.504 19.8417 204.172 19.2696 202.783 19.2679Z",
    fill: "url(#paint46_linear_1604_25275)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M202.783 27.5889C204.328 27.5889 205.58 26.2923 205.58 24.6929C205.58 23.0936 204.328 21.797 202.783 21.797C201.238 21.797 199.986 23.0936 199.986 24.6929C199.986 26.2923 201.238 27.5889 202.783 27.5889Z",
    fill: "url(#paint47_linear_1604_25275)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M263.592 44.4018C263.59 44.9743 263.425 45.5335 263.117 46.0089C262.809 46.4843 262.372 46.8545 261.861 47.0727C261.35 47.291 260.788 47.3474 260.246 47.235C259.703 47.1225 259.206 46.8462 258.815 46.4409C258.425 46.0357 258.159 45.5197 258.051 44.9581C257.944 44.3965 258 43.8146 258.212 43.2858C258.423 42.757 258.782 42.3051 259.242 41.9871C259.701 41.6692 260.242 41.4995 260.795 41.4995C261.163 41.4995 261.527 41.5746 261.867 41.7206C262.206 41.8665 262.515 42.0804 262.775 42.3499C263.034 42.6195 263.24 42.9395 263.381 43.2916C263.521 43.6437 263.593 44.0209 263.592 44.4018Z",
    fill: "url(#paint48_linear_1604_25275)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M208.279 62.3655C209.824 62.3655 211.076 61.0689 211.076 59.4695C211.076 57.8702 209.824 56.5736 208.279 56.5736C206.735 56.5736 205.482 57.8702 205.482 59.4695C205.482 61.0689 206.735 62.3655 208.279 62.3655Z",
    fill: "url(#paint49_linear_1604_25275)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M239.422 83.2313C238.144 83.2313 236.895 82.8389 235.832 82.1038C234.77 81.3688 233.942 80.324 233.453 79.1016C232.964 77.8792 232.836 76.5341 233.085 75.2364C233.334 73.9388 233.95 72.7468 234.853 71.8112C235.757 70.8756 236.908 70.2385 238.161 69.9804C239.415 69.7222 240.714 69.8547 241.894 70.361C243.075 70.8674 244.084 71.7248 244.794 72.8249C245.504 73.925 245.883 75.2184 245.883 76.5415C245.883 78.3158 245.202 80.0173 243.99 81.2719C242.779 82.5265 241.135 83.2313 239.422 83.2313ZM239.422 71.1164C238.385 71.1164 237.372 71.4346 236.511 72.0307C235.649 72.6268 234.978 73.4741 234.581 74.4654C234.185 75.4567 234.081 76.5476 234.283 77.5999C234.485 78.6523 234.984 79.619 235.717 80.3777C236.45 81.1364 237.383 81.6531 238.4 81.8624C239.416 82.0717 240.469 81.9643 241.427 81.5537C242.384 81.1431 243.202 80.4477 243.778 79.5556C244.354 78.6634 244.661 77.6145 244.661 76.5415C244.66 75.1032 244.107 73.7243 243.125 72.7072C242.143 71.6902 240.811 71.1181 239.422 71.1164Z",
    fill: "url(#paint50_linear_1604_25275)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M239.422 79.4375C240.966 79.4375 242.219 78.1409 242.219 76.5416C242.219 74.9422 240.966 73.6456 239.422 73.6456C237.877 73.6456 236.625 74.9422 236.625 76.5416C236.625 78.1409 237.877 79.4375 239.422 79.4375Z",
    fill: "url(#paint51_linear_1604_25275)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M184.463 96.5095C186.007 96.5095 187.26 95.213 187.26 93.6136C187.26 92.0142 186.007 90.7177 184.463 90.7177C182.918 90.7177 181.666 92.0142 181.666 93.6136C181.666 95.213 182.918 96.5095 184.463 96.5095Z",
    fill: "url(#paint52_linear_1604_25275)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M255.91 119.905C257.455 119.905 258.707 118.608 258.707 117.009C258.707 115.409 257.455 114.113 255.91 114.113C254.365 114.113 253.113 115.409 253.113 117.009C253.113 118.608 254.365 119.905 255.91 119.905Z",
    fill: "url(#paint53_linear_1604_25275)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M220.493 140.669C219.213 140.671 217.962 140.279 216.898 139.544C215.834 138.809 215.004 137.764 214.514 136.54C214.023 135.317 213.894 133.97 214.143 132.671C214.392 131.372 215.007 130.178 215.911 129.241C216.816 128.304 217.968 127.665 219.223 127.406C220.477 127.147 221.778 127.28 222.96 127.786C224.142 128.293 225.152 129.151 225.863 130.252C226.574 131.354 226.953 132.649 226.953 133.973C226.953 135.748 226.273 137.45 225.061 138.706C223.85 139.961 222.207 140.668 220.493 140.669ZM220.493 128.548C219.455 128.547 218.44 128.865 217.576 129.461C216.712 130.057 216.039 130.905 215.641 131.898C215.244 132.891 215.139 133.983 215.341 135.038C215.544 136.092 216.043 137.06 216.777 137.82C217.511 138.58 218.446 139.098 219.465 139.307C220.483 139.516 221.538 139.408 222.497 138.996C223.455 138.585 224.275 137.887 224.851 136.993C225.426 136.099 225.733 135.048 225.732 133.973C225.73 132.535 225.178 131.156 224.196 130.139C223.213 129.122 221.882 128.55 220.493 128.548Z",
    fill: "url(#paint54_linear_1604_25275)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M223.289 133.973C223.289 134.546 223.125 135.106 222.818 135.582C222.51 136.058 222.073 136.43 221.562 136.649C221.051 136.868 220.489 136.925 219.946 136.814C219.404 136.702 218.906 136.426 218.514 136.021C218.123 135.616 217.857 135.1 217.749 134.538C217.641 133.977 217.697 133.394 217.908 132.865C218.12 132.336 218.478 131.884 218.938 131.565C219.398 131.247 219.939 131.077 220.492 131.077C221.233 131.079 221.944 131.385 222.468 131.927C222.992 132.47 223.287 133.206 223.289 133.973Z",
    fill: "url(#paint55_linear_1604_25275)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M235.758 154.681C237.302 154.681 238.555 153.385 238.555 151.785C238.555 150.186 237.302 148.889 235.758 148.889C234.213 148.889 232.961 150.186 232.961 151.785C232.961 153.385 234.213 154.681 235.758 154.681Z",
    fill: "url(#paint56_linear_1604_25275)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M187.467 165.272C187.468 165.846 187.305 166.408 186.998 166.886C186.691 167.364 186.253 167.737 185.741 167.958C185.229 168.179 184.665 168.237 184.121 168.126C183.577 168.014 183.077 167.739 182.684 167.333C182.292 166.927 182.024 166.41 181.916 165.847C181.807 165.284 181.862 164.7 182.074 164.169C182.286 163.639 182.645 163.185 183.106 162.866C183.567 162.547 184.11 162.376 184.664 162.376C185.406 162.378 186.117 162.683 186.642 163.226C187.167 163.768 187.464 164.504 187.467 165.272Z",
    fill: "url(#paint57_linear_1604_25275)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M258.212 0.507568H248.014C247.505 0.507568 247.092 0.935036 247.092 1.46234V15.8345C247.092 16.3618 247.505 16.7893 248.014 16.7893H258.212C258.721 16.7893 259.134 16.3618 259.134 15.8345V1.46234C259.134 0.935036 258.721 0.507568 258.212 0.507568Z",
    fill: "url(#paint58_linear_1604_25275)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M258.212 0.507568H248.014C247.505 0.507568 247.092 0.935036 247.092 1.46234V15.8345C247.092 16.3618 247.505 16.7893 248.014 16.7893H258.212C258.721 16.7893 259.134 16.3618 259.134 15.8345V1.46234C259.134 0.935036 258.721 0.507568 258.212 0.507568Z",
    fill: "#DCEAF8"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M257.332 2.82178H248.887V3.70067H257.332V2.82178Z",
    fill: "url(#paint59_linear_1604_25275)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M257.332 4.35828H248.887V5.23718H257.332V4.35828Z",
    fill: "url(#paint60_linear_1604_25275)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M257.332 5.901H248.887V6.7799H257.332V5.901Z",
    fill: "url(#paint61_linear_1604_25275)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M257.332 7.4375H248.887V8.3164H257.332V7.4375Z",
    fill: "url(#paint62_linear_1604_25275)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M257.332 8.98035H248.887V9.85924H257.332V8.98035Z",
    fill: "url(#paint63_linear_1604_25275)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M257.332 10.5232H248.887V11.4021H257.332V10.5232Z",
    fill: "url(#paint64_linear_1604_25275)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M257.332 12.0597H248.887V12.9386H257.332V12.0597Z",
    fill: "url(#paint65_linear_1604_25275)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M254.358 13.6025H248.887V14.4814H254.358V13.6025Z",
    fill: "url(#paint66_linear_1604_25275)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M201.47 86.8417H191.272C190.762 86.8417 190.35 87.2691 190.35 87.7965V102.169C190.35 102.696 190.762 103.123 191.272 103.123H201.47C201.979 103.123 202.392 102.696 202.392 102.169V87.7965C202.392 87.2691 201.979 86.8417 201.47 86.8417Z",
    fill: "url(#paint67_linear_1604_25275)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M201.47 86.8417H191.272C190.762 86.8417 190.35 87.2691 190.35 87.7965V102.169C190.35 102.696 190.762 103.123 191.272 103.123H201.47C201.979 103.123 202.392 102.696 202.392 102.169V87.7965C202.392 87.2691 201.979 86.8417 201.47 86.8417Z",
    fill: "#DCEAF8"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M200.59 89.1497H192.145V90.0286H200.59V89.1497Z",
    fill: "url(#paint68_linear_1604_25275)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M200.59 90.6925H192.145V91.5714H200.59V90.6925Z",
    fill: "url(#paint69_linear_1604_25275)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M200.59 92.2289H192.145V93.1078H200.59V92.2289Z",
    fill: "url(#paint70_linear_1604_25275)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M200.59 93.7717H192.145V94.6506H200.59V93.7717Z",
    fill: "url(#paint71_linear_1604_25275)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M200.59 95.3081H192.145V96.187H200.59V95.3081Z",
    fill: "url(#paint72_linear_1604_25275)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M200.59 96.851H192.145V97.7299H200.59V96.851Z",
    fill: "url(#paint73_linear_1604_25275)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M200.59 98.3938H192.145V99.2727H200.59V98.3938Z",
    fill: "url(#paint74_linear_1604_25275)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M197.616 99.9303H192.145V100.809H197.616V99.9303Z",
    fill: "url(#paint75_linear_1604_25275)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M271.915 104.363H261.717C261.208 104.363 260.795 104.79 260.795 105.318V119.69C260.795 120.217 261.208 120.645 261.717 120.645H271.915C272.424 120.645 272.837 120.217 272.837 119.69V105.318C272.837 104.79 272.424 104.363 271.915 104.363Z",
    fill: "url(#paint76_linear_1604_25275)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M271.915 104.363H261.717C261.208 104.363 260.795 104.79 260.795 105.318V119.69C260.795 120.217 261.208 120.645 261.717 120.645H271.915C272.424 120.645 272.837 120.217 272.837 119.69V105.318C272.837 104.79 272.424 104.363 271.915 104.363Z",
    fill: "#DCEAF8"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M271.035 106.677H262.59V107.556H271.035V106.677Z",
    fill: "url(#paint77_linear_1604_25275)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M271.035 108.213H262.59V109.092H271.035V108.213Z",
    fill: "url(#paint78_linear_1604_25275)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M271.035 109.756H262.59V110.635H271.035V109.756Z",
    fill: "url(#paint79_linear_1604_25275)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M271.035 111.299H262.59V112.178H271.035V111.299Z",
    fill: "url(#paint80_linear_1604_25275)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M271.035 112.836H262.59V113.714H271.035V112.836Z",
    fill: "url(#paint81_linear_1604_25275)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M271.035 114.378H262.59V115.257H271.035V114.378Z",
    fill: "url(#paint82_linear_1604_25275)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M271.035 115.915H262.59V116.794H271.035V115.915Z",
    fill: "url(#paint83_linear_1604_25275)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M268.061 117.458H262.59V118.337H268.061V117.458Z",
    fill: "url(#paint84_linear_1604_25275)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M276.69 31.7242H266.492C265.983 31.7242 265.57 32.1517 265.57 32.679V47.0512C265.57 47.5785 265.983 48.0059 266.492 48.0059H276.69C277.2 48.0059 277.613 47.5785 277.613 47.0512V32.679C277.613 32.1517 277.2 31.7242 276.69 31.7242Z",
    fill: "url(#paint85_linear_1604_25275)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M276.69 31.7242H266.492C265.983 31.7242 265.57 32.1517 265.57 32.679V47.0512C265.57 47.5785 265.983 48.0059 266.492 48.0059H276.69C277.2 48.0059 277.613 47.5785 277.613 47.0512V32.679C277.613 32.1517 277.2 31.7242 276.69 31.7242Z",
    fill: "#DCEAF8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M275.811 34.0383H267.365V34.9172H275.811V34.0383Z",
    fill: "url(#paint86_linear_1604_25275)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M275.811 35.5748H267.365V36.4537H275.811V35.5748Z",
    fill: "url(#paint87_linear_1604_25275)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M275.811 37.1177H267.365V37.9966H275.811V37.1177Z",
    fill: "url(#paint88_linear_1604_25275)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M275.811 38.6605H267.365V39.5394H275.811V38.6605Z",
    fill: "url(#paint89_linear_1604_25275)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M275.811 40.197H267.365V41.0759H275.811V40.197Z",
    fill: "url(#paint90_linear_1604_25275)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M275.811 41.7399H267.365V42.6188H275.811V41.7399Z",
    fill: "url(#paint91_linear_1604_25275)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M275.811 43.2762H267.365V44.1551H275.811V43.2762Z",
    fill: "url(#paint92_linear_1604_25275)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M272.837 44.8191H267.365V45.698H272.837V44.8191Z",
    fill: "url(#paint93_linear_1604_25275)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M201.696 162.035H191.498C190.989 162.035 190.576 162.462 190.576 162.989V177.362C190.576 177.889 190.989 178.316 191.498 178.316H201.696C202.206 178.316 202.618 177.889 202.618 177.362V162.989C202.618 162.462 202.206 162.035 201.696 162.035Z",
    fill: "url(#paint94_linear_1604_25275)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M201.696 162.035H191.498C190.989 162.035 190.576 162.462 190.576 162.989V177.362C190.576 177.889 190.989 178.316 191.498 178.316H201.696C202.206 178.316 202.618 177.889 202.618 177.362V162.989C202.618 162.462 202.206 162.035 201.696 162.035Z",
    fill: "#DCEAF8"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M200.817 164.349H192.371V165.228H200.817V164.349Z",
    fill: "url(#paint95_linear_1604_25275)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M200.817 165.885H192.371V166.764H200.817V165.885Z",
    fill: "url(#paint96_linear_1604_25275)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M200.817 167.428H192.371V168.307H200.817V167.428Z",
    fill: "url(#paint97_linear_1604_25275)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M200.817 168.965H192.371V169.844H200.817V168.965Z",
    fill: "url(#paint98_linear_1604_25275)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M200.817 170.507H192.371V171.386H200.817V170.507Z",
    fill: "url(#paint99_linear_1604_25275)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M200.817 172.05H192.371V172.929H200.817V172.05Z",
    fill: "url(#paint100_linear_1604_25275)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M200.817 173.587H192.371V174.466H200.817V173.587Z",
    fill: "url(#paint101_linear_1604_25275)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M197.843 175.13H192.371V176.009H197.843V175.13Z",
    fill: "url(#paint102_linear_1604_25275)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M275.695 61.651H249.485C248.966 61.651 248.545 62.087 248.545 62.6247V89.763C248.545 90.3008 248.966 90.7368 249.485 90.7368H275.695C276.214 90.7368 276.635 90.3008 276.635 89.763V62.6247C276.635 62.087 276.214 61.651 275.695 61.651Z",
    fill: "url(#paint103_linear_1604_25275)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M262.59 85.9945C267.818 85.9945 272.055 81.6066 272.055 76.1938C272.055 70.7811 267.818 66.3932 262.59 66.3932C257.363 66.3932 253.125 70.7811 253.125 76.1938C253.125 81.6066 257.363 85.9945 262.59 85.9945Z",
    fill: "#DCEAF8"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M262.591 76.1938H272.056C272.051 78.3472 271.361 80.4386 270.091 82.1443C268.822 83.8499 267.045 85.0745 265.035 85.6284C263.025 86.1823 260.895 86.0345 258.975 85.2079C257.055 84.3814 255.451 82.9222 254.413 81.0565C253.375 79.1907 252.959 77.0225 253.232 74.8877C253.504 72.7529 254.449 70.7707 255.919 69.2482C257.39 67.7256 259.305 66.7477 261.366 66.4659C263.428 66.1841 265.522 66.6141 267.324 67.6894L262.591 76.1938Z",
    fill: "#DCEAF8"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M262.59 83.7814C266.637 83.7814 269.918 80.3843 269.918 76.1938C269.918 72.0033 266.637 68.6062 262.59 68.6062C258.543 68.6062 255.262 72.0033 255.262 76.1938C255.262 80.3843 258.543 83.7814 262.59 83.7814Z",
    fill: "url(#paint104_linear_1604_25275)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M262.59 83.7814C266.637 83.7814 269.918 80.3843 269.918 76.1938C269.918 72.0033 266.637 68.6062 262.59 68.6062C258.543 68.6062 255.262 72.0033 255.262 76.1938C255.262 80.3843 258.543 83.7814 262.59 83.7814Z",
    fill: "#DCEAF8"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M261.211 80.0089C260.924 80.0089 260.671 79.958 260.45 79.8562C260.231 79.7531 260.061 79.6116 259.938 79.4318C259.815 79.2505 259.755 79.0442 259.756 78.8128C259.755 78.6316 259.79 78.4644 259.863 78.311C259.935 78.1563 260.034 78.0273 260.16 77.9242C260.287 77.8196 260.428 77.7534 260.584 77.7255V77.7005C260.379 77.6475 260.216 77.5325 260.095 77.3555C259.974 77.177 259.914 76.9742 259.915 76.747C259.914 76.5295 259.969 76.3351 260.08 76.1636C260.192 75.9922 260.345 75.8569 260.54 75.758C260.737 75.659 260.961 75.6095 261.211 75.6095C261.46 75.6095 261.681 75.659 261.876 75.758C262.072 75.8569 262.225 75.9922 262.336 76.1636C262.449 76.3351 262.506 76.5295 262.508 76.747C262.506 76.9742 262.444 77.177 262.322 77.3555C262.2 77.5325 262.039 77.6475 261.839 77.7005V77.7255C261.993 77.7534 262.133 77.8196 262.257 77.9242C262.381 78.0273 262.48 78.1563 262.554 78.311C262.628 78.4644 262.665 78.6316 262.667 78.8128C262.665 79.0442 262.603 79.2505 262.479 79.4318C262.356 79.6116 262.185 79.7531 261.966 79.8562C261.749 79.958 261.497 80.0089 261.211 80.0089ZM261.211 79.5489C261.405 79.5489 261.572 79.5175 261.713 79.4548C261.854 79.392 261.963 79.3035 262.039 79.1892C262.116 79.0749 262.155 78.9411 262.157 78.7878C262.155 78.6261 262.113 78.4832 262.031 78.3591C261.949 78.235 261.837 78.1375 261.694 78.0664C261.554 77.9953 261.393 77.9597 261.211 77.9597C261.029 77.9597 260.866 77.9953 260.722 78.0664C260.58 78.1375 260.468 78.235 260.386 78.3591C260.305 78.4832 260.265 78.6261 260.266 78.7878C260.265 78.9411 260.302 79.0749 260.377 79.1892C260.454 79.3035 260.563 79.392 260.705 79.4548C260.848 79.5175 261.016 79.5489 261.211 79.5489ZM261.211 77.5165C261.365 77.5165 261.501 77.4858 261.619 77.4245C261.739 77.3631 261.833 77.2774 261.901 77.1673C261.97 77.0571 262.005 76.9282 262.006 76.7804C262.005 76.6355 261.97 76.5093 261.904 76.402C261.837 76.2932 261.744 76.2096 261.625 76.1511C261.507 76.0911 261.369 76.0612 261.211 76.0612C261.051 76.0612 260.911 76.0911 260.791 76.1511C260.671 76.2096 260.579 76.2932 260.513 76.402C260.448 76.5093 260.415 76.6355 260.417 76.7804C260.415 76.9282 260.448 77.0571 260.515 77.1673C260.583 77.2774 260.678 77.3631 260.797 77.4245C260.917 77.4858 261.055 77.5165 261.211 77.5165ZM264.865 80.0089C264.55 80.0089 264.281 79.9231 264.06 79.7517C263.838 79.5788 263.669 79.3286 263.552 79.001C263.435 78.6721 263.376 78.2748 263.376 77.8092C263.376 77.3464 263.435 76.9512 263.552 76.6236C263.67 76.2946 263.84 76.0437 264.062 75.8709C264.285 75.6966 264.553 75.6095 264.865 75.6095C265.177 75.6095 265.444 75.6966 265.666 75.8709C265.889 76.0437 266.059 76.2946 266.176 76.6236C266.294 76.9512 266.354 77.3464 266.354 77.8092C266.354 78.2748 266.295 78.6721 266.178 79.001C266.061 79.3286 265.891 79.5788 265.67 79.7517C265.448 79.9231 265.18 80.0089 264.865 80.0089ZM264.865 79.5489C265.177 79.5489 265.42 79.3983 265.592 79.0972C265.765 78.7961 265.852 78.3668 265.852 77.8092C265.852 77.4384 265.812 77.1227 265.733 76.862C265.655 76.6013 265.542 76.4027 265.394 76.2661C265.247 76.1295 265.071 76.0612 264.865 76.0612C264.555 76.0612 264.314 76.2138 264.139 76.5191C263.965 76.823 263.878 77.253 263.878 77.8092C263.878 78.18 263.917 78.495 263.995 78.7543C264.073 79.0136 264.185 79.2108 264.332 79.346C264.479 79.4812 264.657 79.5489 264.865 79.5489ZM262.023 86.1474V85.9216C262.023 85.7654 262.055 85.6226 262.119 85.4929C262.184 85.3619 262.279 85.2573 262.403 85.1793C262.529 85.0998 262.681 85.0601 262.859 85.0601C263.04 85.0601 263.192 85.0998 263.315 85.1793C263.438 85.2573 263.53 85.3619 263.593 85.4929C263.656 85.6226 263.687 85.7654 263.687 85.9216V86.1474C263.687 86.3035 263.655 86.4471 263.591 86.5781C263.528 86.7078 263.435 86.8123 263.311 86.8918C263.188 86.9698 263.038 87.0089 262.859 87.0089C262.678 87.0089 262.525 86.9698 262.401 86.8918C262.277 86.8123 262.183 86.7078 262.119 86.5781C262.055 86.4471 262.023 86.3035 262.023 86.1474ZM262.449 85.9216V86.1474C262.449 86.277 262.48 86.3934 262.541 86.4966C262.603 86.5983 262.709 86.6492 262.859 86.6492C263.005 86.6492 263.109 86.5983 263.169 86.4966C263.23 86.3934 263.261 86.277 263.261 86.1474V85.9216C263.261 85.7919 263.231 85.6762 263.173 85.5745C263.114 85.4713 263.01 85.4197 262.859 85.4197C262.713 85.4197 262.607 85.4713 262.543 85.5745C262.481 85.6762 262.449 85.7919 262.449 85.9216ZM259.89 83.6968V83.471C259.89 83.3149 259.922 83.172 259.986 83.0423C260.052 82.9113 260.146 82.8068 260.271 82.7287C260.396 82.6492 260.548 82.6095 260.726 82.6095C260.908 82.6095 261.059 82.6492 261.182 82.7287C261.305 82.8068 261.398 82.9113 261.46 83.0423C261.523 83.172 261.554 83.3149 261.554 83.471V83.6968C261.554 83.8529 261.522 83.9965 261.458 84.1275C261.395 84.2572 261.302 84.3617 261.178 84.4412C261.055 84.5192 260.905 84.5583 260.726 84.5583C260.545 84.5583 260.392 84.5192 260.268 84.4412C260.144 84.3617 260.05 84.2572 259.986 84.1275C259.922 83.9965 259.89 83.8529 259.89 83.6968ZM260.317 83.471V83.6968C260.317 83.8264 260.347 83.9428 260.409 84.046C260.47 84.1477 260.576 84.1986 260.726 84.1986C260.873 84.1986 260.976 84.1477 261.036 84.046C261.097 83.9428 261.128 83.8264 261.128 83.6968V83.471C261.128 83.3413 261.099 83.2256 261.04 83.1239C260.981 83.0207 260.877 82.9692 260.726 82.9692C260.58 82.9692 260.475 83.0207 260.411 83.1239C260.348 83.2256 260.317 83.3413 260.317 83.471ZM260.049 86.9503L262.993 82.6681H263.47L260.526 86.9503H260.049Z",
    fill: "#DCEAF8"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M249.608 123.016H229.664C229.269 123.016 228.949 123.347 228.949 123.755V144.406C228.949 144.815 229.269 145.146 229.664 145.146H249.608C250.002 145.146 250.322 144.815 250.322 144.406V123.755C250.322 123.347 250.002 123.016 249.608 123.016Z",
    fill: "url(#paint105_linear_1604_25275)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M246.445 141.434H243.697V142.882H246.445V141.434Z",
    fill: "#DCEAF8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M246.445 126.986H243.697V128.434H246.445V126.986Z",
    fill: "#DCEAF8"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M246.445 129.396H243.697V130.843H246.445V129.396Z",
    fill: "#DCEAF8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M246.445 131.804H243.697V133.252H246.445V131.804Z",
    fill: "#DCEAF8"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M246.445 134.207H243.697V135.655H246.445V134.207Z",
    fill: "#DCEAF8"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M246.445 136.616H243.697V138.064H246.445V136.616Z",
    fill: "#DCEAF8"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M246.445 139.025H243.697V140.473H246.445V139.025Z",
    fill: "#DCEAF8"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.707 141.434H239.959V142.882H242.707V141.434Z",
    fill: "#DCEAF8"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M242.707 134.207H239.959V135.655H242.707V134.207Z",
    fill: "#DCEAF8"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M242.707 136.616H239.959V138.064H242.707V136.616Z",
    fill: "#DCEAF8"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.707 139.025H239.959V140.473H242.707V139.025Z",
    fill: "#DCEAF8"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M238.963 141.434H236.215V142.882H238.963V141.434Z",
    fill: "#DCEAF8"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M238.963 131.804H236.215V133.252H238.963V131.804Z",
    fill: "#DCEAF8"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M238.963 134.207H236.215V135.655H238.963V134.207Z",
    fill: "#DCEAF8"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M238.963 136.616H236.215V138.064H238.963V136.616Z",
    fill: "#DCEAF8"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M238.963 139.025H236.215V140.473H238.963V139.025Z",
    fill: "#DCEAF8"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M235.226 141.434H232.479V142.882H235.226V141.434Z",
    fill: "#DCEAF8"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M235.226 136.616H232.479V138.064H235.226V136.616Z",
    fill: "#DCEAF8"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M235.226 139.025H232.479V140.473H235.226V139.025Z",
    fill: "#DCEAF8"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M233.26 16.5237H213.316C212.921 16.5237 212.602 16.8549 212.602 17.2635V37.9144C212.602 38.3229 212.921 38.6542 213.316 38.6542H233.26C233.655 38.6542 233.975 38.3229 233.975 37.9144V17.2635C233.975 16.8549 233.655 16.5237 233.26 16.5237Z",
    fill: "url(#paint106_linear_1604_25275)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M224.834 25.1862V23.8014L224.144 23.7382C224.053 23.2864 223.879 22.8569 223.631 22.4736L224.07 21.9172L223.13 20.8992L222.592 21.3607C222.222 21.1048 221.807 20.9245 221.371 20.8296L221.304 20.1151H219.967L219.906 20.8296C219.47 20.9253 219.055 21.1055 218.684 21.3607L218.153 20.8992L217.206 21.8792L217.646 22.4356C217.402 22.8214 217.229 23.2499 217.133 23.7002L216.449 23.7635V25.1482L217.133 25.2178C217.23 25.6675 217.404 26.0958 217.646 26.4824L217.206 27.0388L218.153 28.0189L218.684 27.5573C219.055 27.8125 219.47 27.9928 219.906 28.0884L219.967 28.8029H221.304L221.371 28.0884C221.807 27.9935 222.222 27.8132 222.592 27.5573L223.13 28.0189L224.07 27.0388L223.631 26.4824C223.878 26.0985 224.052 25.6693 224.144 25.2178L224.834 25.1862ZM220.626 26.3686C220.264 26.3686 219.91 26.2573 219.608 26.0489C219.307 25.8404 219.072 25.5442 218.934 25.1976C218.795 24.851 218.759 24.4695 218.829 24.1016C218.9 23.7336 219.075 23.3956 219.331 23.1303C219.587 22.8651 219.913 22.6844 220.269 22.6112C220.624 22.538 220.992 22.5756 221.327 22.7191C221.662 22.8627 221.948 23.1059 222.149 23.4178C222.351 23.7297 222.458 24.0965 222.458 24.4717C222.458 24.9747 222.265 25.4572 221.922 25.813C221.578 26.1687 221.112 26.3686 220.626 26.3686Z",
    fill: "#DCEAF8"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M230.263 29.1191V28.0315L229.726 27.9809C229.653 27.6228 229.516 27.2819 229.323 26.9756L229.671 26.5456L228.932 25.7742L228.511 26.1346C228.217 25.9344 227.89 25.7928 227.546 25.7173L227.491 25.1609H226.446L226.392 25.7173C226.048 25.7928 225.72 25.9344 225.427 26.1346L225.005 25.7742L224.266 26.5456L224.614 26.9756C224.418 27.2805 224.282 27.6219 224.211 27.9809L223.668 28.0315V29.1191L224.211 29.1697C224.282 29.5267 224.419 29.8661 224.614 30.1687L224.266 30.605L225.005 31.3701L225.427 31.016C225.721 31.2143 226.048 31.3537 226.392 31.427L226.446 31.9897H227.491L227.546 31.427C227.889 31.3537 228.217 31.2143 228.511 31.016L228.932 31.3701L229.671 30.605L229.323 30.1687C229.516 29.8647 229.653 29.5258 229.726 29.1697L230.263 29.1191ZM226.966 30.0422C226.684 30.0422 226.409 29.9557 226.174 29.7935C225.94 29.6313 225.758 29.4009 225.65 29.1313C225.543 28.8617 225.515 28.5652 225.57 28.2792C225.626 27.9933 225.762 27.7308 225.962 27.525C226.161 27.3192 226.415 27.1794 226.692 27.1233C226.968 27.0671 227.254 27.0972 227.514 27.2097C227.774 27.3222 227.996 27.512 228.152 27.7551C228.307 27.9982 228.39 28.2837 228.388 28.5753C228.386 28.768 228.347 28.9582 228.274 29.1353C228.2 29.3123 228.094 29.4726 227.96 29.6071C227.827 29.7415 227.67 29.8475 227.497 29.9189C227.324 29.9903 227.139 30.0258 226.953 30.0233L226.966 30.0422Z",
    fill: "#DCEAF8"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M224.833 32.1795V31.2689L224.381 31.2247C224.319 30.9225 224.203 30.6351 224.039 30.3774L224.332 30.017L223.721 29.3847L223.367 29.6882C223.122 29.5145 222.846 29.394 222.555 29.3341L222.512 28.8662H221.633L221.59 29.3341C221.3 29.3963 221.024 29.5166 220.778 29.6882L220.43 29.3847L219.819 30.017L220.106 30.3774C219.944 30.6354 219.83 30.9229 219.77 31.2247L219.318 31.2689V32.1795L219.77 32.2237C219.831 32.5232 219.945 32.8084 220.106 33.0647L219.819 33.4251L220.43 34.0574L220.778 33.7602C221.025 33.9273 221.301 34.0452 221.59 34.108L221.633 34.5759H222.512L222.555 34.108C222.845 34.0476 223.121 33.9295 223.367 33.7602L223.721 34.0574L224.332 33.4251L224.039 33.0647C224.202 32.8087 224.318 32.5235 224.381 32.2237L224.833 32.1795ZM222.06 32.9572C221.825 32.9572 221.594 32.8849 221.399 32.7494C221.203 32.6139 221.05 32.4213 220.96 32.196C220.87 31.9707 220.846 31.7228 220.892 31.4837C220.938 31.2445 221.052 31.0248 221.218 30.8524C221.385 30.6799 221.597 30.5625 221.828 30.5149C222.059 30.4673 222.298 30.4918 222.516 30.5851C222.734 30.6784 222.919 30.8364 223.05 31.0392C223.181 31.242 223.251 31.4803 223.251 31.7242C223.243 32.0487 223.115 32.3577 222.894 32.5872C222.672 32.8167 222.374 32.9492 222.06 32.9572Z",
    fill: "#DCEAF8"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M231.905 52.9884H213.127V65.6344H231.905V52.9884Z",
    fill: "url(#paint107_linear_1604_25275)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M231.905 52.9884H213.127V65.6344H231.905V52.9884Z",
    fill: "#DCEAF8"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M231.214 55.3596H213.811V65.0022H231.214V55.3596Z",
    fill: "url(#paint108_linear_1604_25275)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M228.101 56.8011H215.229V57.2185H228.101V56.8011Z",
    fill: "#DCEAF8"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M221.408 58.0721H215.229V58.4895H221.408V58.0721Z",
    fill: "#DCEAF8"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M223.008 59.343H215.229V59.7603H223.008V59.343Z",
    fill: "#DCEAF8"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M217.97 60.6139H215.229V61.0312H217.97V60.6139Z",
    fill: "#DCEAF8"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M217.006 61.8849H215.229V62.3022H217.006V61.8849Z",
    fill: "#DCEAF8"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M261.827 149.414H243.049V162.06H261.827V149.414Z",
    fill: "url(#paint109_linear_1604_25275)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M261.827 149.414H243.049V162.06H261.827V149.414Z",
    fill: "#DCEAF8"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M261.136 151.785H243.732V161.428H261.136V151.785Z",
    fill: "url(#paint110_linear_1604_25275)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M258.023 153.227H245.15V153.644H258.023V153.227Z",
    fill: "#DCEAF8"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M251.33 154.498H245.15V154.915H251.33V154.498Z",
    fill: "#DCEAF8"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M252.93 155.769H245.15V156.186H252.93V155.769Z",
    fill: "#DCEAF8"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M247.892 157.04H245.15V157.457H247.892V157.04Z",
    fill: "#DCEAF8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M246.927 158.31H245.15V158.728H246.927V158.31Z",
    fill: "#DCEAF8"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.925 75.9093H130.113V77.1739H233.925V75.9093Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.452 70.8508H125.23V63.2632C125.23 63.18 125.245 63.0975 125.276 63.0205C125.306 62.9435 125.351 62.8734 125.408 62.8143L162.762 24.244C162.819 24.1854 162.886 24.1391 162.961 24.1076C163.035 24.0761 163.115 24.0602 163.195 24.0607H197.288V25.3253H163.446L126.452 63.5225V70.8508Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.997 134.713H169.198C169.118 134.714 169.038 134.698 168.964 134.666C168.889 134.635 168.821 134.588 168.764 134.53L125.408 89.6366C125.351 89.5775 125.306 89.5074 125.276 89.4304C125.245 89.3533 125.23 89.2708 125.23 89.1876V82.8646H126.452V88.9284L169.448 133.449H214.997V134.713Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.463 94.2459H159.933C159.773 94.2452 159.619 94.1793 159.505 94.0625L143.018 77.0979L143.879 76.2001L160.189 92.9813H184.463V94.2459Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.492 77.041L166.625 76.1495L183.058 59.0205C183.175 58.905 183.33 58.8395 183.491 58.8372H208.278V60.1018H183.748L167.492 77.041Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.796 44.9265H163.841C163.761 44.9262 163.681 44.9092 163.606 44.8767C163.532 44.8441 163.464 44.7966 163.408 44.7368L153.674 34.5568L154.541 33.6653L164.098 43.6619H260.796V44.9265Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.307 25.142L173.471 24.2441L189.348 7.80435C189.405 7.74575 189.473 7.69938 189.547 7.66792C189.621 7.63645 189.701 7.6205 189.781 7.62098H240.643V8.88558H190.007L174.307 25.142Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.237 165.696L159.603 140.195C159.494 140.082 159.431 139.931 159.426 139.771V124.596H160.647V139.512L185.074 164.804L184.237 165.696Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.686 134.327L177.818 133.448L194.013 116.572C194.13 116.457 194.285 116.391 194.447 116.389H255.91V117.654H194.703L178.686 134.327Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.758 152.417H208.382C208.302 152.418 208.222 152.402 208.148 152.37C208.073 152.339 208.005 152.293 207.948 152.234L190.746 134.422L191.613 133.531L208.632 151.153H235.758V152.417Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.643 11.1492C242.187 11.1492 243.439 9.85261 243.439 8.25323C243.439 6.65385 242.187 5.3573 240.643 5.3573C239.098 5.3573 237.846 6.65385 237.846 8.25323C237.846 9.85261 239.098 11.1492 240.643 11.1492Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.783 31.3828C201.505 31.3828 200.256 30.9904 199.194 30.2553C198.131 29.5203 197.303 28.4755 196.814 27.2531C196.325 26.0307 196.197 24.6856 196.446 23.3879C196.696 22.0902 197.311 20.8982 198.215 19.9627C199.118 19.0271 200.269 18.39 201.523 18.1318C202.776 17.8737 204.075 18.0062 205.255 18.5125C206.436 19.0189 207.445 19.8763 208.155 20.9764C208.865 22.0765 209.244 23.3699 209.244 24.693C209.244 26.4673 208.563 28.1688 207.352 29.4234C206.14 30.6779 204.497 31.3828 202.783 31.3828ZM202.783 19.2679C201.747 19.2679 200.734 19.5861 199.872 20.1822C199.011 20.7783 198.339 21.6256 197.942 22.6169C197.546 23.6082 197.442 24.699 197.644 25.7514C197.846 26.8038 198.345 27.7705 199.078 28.5292C199.811 29.2879 200.745 29.8046 201.761 30.0139C202.777 30.2232 203.831 30.1158 204.788 29.7052C205.745 29.2946 206.564 28.5992 207.139 27.7071C207.715 26.8149 208.023 25.766 208.023 24.693C208.021 23.2547 207.468 21.8758 206.486 20.8587C205.504 19.8417 204.172 19.2696 202.783 19.2679Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.592 44.4018C263.59 44.9743 263.425 45.5335 263.117 46.0089C262.809 46.4843 262.372 46.8545 261.861 47.0727C261.35 47.291 260.788 47.3474 260.245 47.235C259.703 47.1225 259.206 46.8462 258.815 46.4409C258.425 46.0357 258.159 45.5197 258.051 44.9581C257.944 44.3965 258 43.8146 258.212 43.2858C258.423 42.757 258.782 42.3051 259.242 41.9871C259.701 41.6692 260.242 41.4995 260.795 41.4995C261.163 41.4995 261.527 41.5746 261.867 41.7206C262.206 41.8665 262.515 42.0804 262.775 42.3499C263.034 42.6195 263.24 42.9395 263.381 43.2916C263.521 43.6437 263.592 44.0209 263.592 44.4018Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.279 62.3653C209.824 62.3653 211.076 61.0688 211.076 59.4694C211.076 57.87 209.824 56.5735 208.279 56.5735C206.735 56.5735 205.482 57.87 205.482 59.4694C205.482 61.0688 206.735 62.3653 208.279 62.3653Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.422 83.2313C238.144 83.2313 236.895 82.8389 235.832 82.1038C234.77 81.3688 233.942 80.324 233.453 79.1016C232.964 77.8792 232.836 76.5341 233.085 75.2364C233.334 73.9388 233.95 72.7468 234.853 71.8112C235.757 70.8756 236.908 70.2385 238.161 69.9804C239.415 69.7222 240.714 69.8547 241.894 70.361C243.075 70.8674 244.084 71.7248 244.794 72.8249C245.504 73.925 245.882 75.2184 245.882 76.5415C245.882 78.3158 245.202 80.0173 243.99 81.2719C242.779 82.5265 241.135 83.2313 239.422 83.2313ZM239.422 71.1164C238.385 71.1164 237.372 71.4346 236.511 72.0307C235.649 72.6268 234.978 73.4741 234.581 74.4654C234.185 75.4567 234.081 76.5476 234.283 77.5999C234.485 78.6523 234.984 79.619 235.717 80.3777C236.45 81.1364 237.383 81.6531 238.4 81.8624C239.416 82.0718 240.469 81.9643 241.427 81.5537C242.384 81.1431 243.202 80.4477 243.778 79.5556C244.354 78.6634 244.661 77.6145 244.661 76.5415C244.66 75.1032 244.107 73.7243 243.125 72.7072C242.143 71.6902 240.811 71.1181 239.422 71.1164Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.463 96.5096C186.007 96.5096 187.26 95.2131 187.26 93.6137C187.26 92.0143 186.007 90.7178 184.463 90.7178C182.918 90.7178 181.666 92.0143 181.666 93.6137C181.666 95.2131 182.918 96.5096 184.463 96.5096Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.91 119.905C257.455 119.905 258.707 118.608 258.707 117.009C258.707 115.409 257.455 114.113 255.91 114.113C254.365 114.113 253.113 115.409 253.113 117.009C253.113 118.608 254.365 119.905 255.91 119.905Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.493 140.669C219.213 140.671 217.962 140.279 216.898 139.544C215.834 138.809 215.004 137.764 214.514 136.54C214.023 135.317 213.894 133.97 214.143 132.671C214.392 131.372 215.007 130.178 215.911 129.241C216.816 128.304 217.968 127.665 219.223 127.406C220.477 127.147 221.778 127.28 222.96 127.786C224.142 128.293 225.152 129.151 225.863 130.252C226.574 131.354 226.953 132.649 226.953 133.973C226.953 135.748 226.273 137.45 225.061 138.706C223.85 139.961 222.207 140.668 220.493 140.669ZM220.493 128.548C219.455 128.547 218.44 128.865 217.576 129.461C216.712 130.057 216.039 130.905 215.641 131.898C215.244 132.891 215.139 133.983 215.341 135.038C215.544 136.092 216.043 137.06 216.777 137.82C217.511 138.58 218.446 139.098 219.465 139.307C220.483 139.516 221.538 139.408 222.497 138.996C223.455 138.585 224.275 137.887 224.851 136.993C225.426 136.099 225.733 135.048 225.732 133.973C225.73 132.535 225.178 131.156 224.196 130.139C223.213 129.122 221.882 128.55 220.493 128.548Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.758 154.681C237.302 154.681 238.555 153.385 238.555 151.785C238.555 150.186 237.302 148.889 235.758 148.889C234.213 148.889 232.961 150.186 232.961 151.785C232.961 153.385 234.213 154.681 235.758 154.681Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.467 165.272C187.468 165.846 187.305 166.408 186.998 166.886C186.691 167.364 186.253 167.737 185.741 167.958C185.229 168.179 184.665 168.237 184.121 168.126C183.577 168.014 183.077 167.739 182.684 167.333C182.292 166.927 182.024 166.41 181.916 165.847C181.807 165.284 181.862 164.7 182.074 164.169C182.286 163.639 182.645 163.185 183.106 162.866C183.567 162.547 184.11 162.376 184.664 162.376C185.406 162.378 186.117 162.683 186.642 163.226C187.167 163.768 187.464 164.504 187.467 165.272Z",
    fill: "#DCEAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84 83.9078C124.436 83.9053 123.065 83.4722 121.899 82.6633C120.733 81.8543 119.824 80.7057 119.288 79.3625C118.752 78.0193 118.613 76.5418 118.887 75.1165C119.161 73.6912 119.838 72.3821 120.83 71.3544C121.823 70.3267 123.087 69.6266 124.463 69.3425C125.84 69.0583 127.267 69.2029 128.564 69.7579C129.861 70.3129 130.971 71.2535 131.752 72.4609C132.533 73.6682 132.952 75.0882 132.954 76.5416C132.956 77.5094 132.773 78.468 132.416 79.3625C132.059 80.2569 131.535 81.0697 130.874 81.754C130.213 82.4384 129.428 82.9809 128.564 83.3505C127.7 83.7201 126.774 83.9095 125.84 83.9078ZM125.84 71.0975C124.797 71.0975 123.779 71.4175 122.912 72.0171C122.045 72.6167 121.37 73.4689 120.971 74.466C120.572 75.4631 120.468 76.5602 120.671 77.6188C120.874 78.6773 121.376 79.6496 122.113 80.4127C122.85 81.1758 123.789 81.6955 124.812 81.9061C125.834 82.1166 126.894 82.0086 127.856 81.5956C128.819 81.1826 129.643 80.4832 130.222 79.5858C130.801 78.6884 131.11 77.6334 131.11 76.5542C131.108 75.1075 130.552 73.7205 129.564 72.6975C128.576 71.6746 127.237 71.0991 125.84 71.0975Z",
    fill: "#DCEAF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1604_25275",
    x1: 41.0996,
    y1: 204.69,
    x2: 66.7535,
    y2: 203.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1604_25275",
    x1: 41.0996,
    y1: 204.69,
    x2: 66.7535,
    y2: 203.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1604_25275",
    x1: 41.1113,
    y1: 221.009,
    x2: 66.4968,
    y2: 218.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1604_25275",
    x1: 40.0918,
    y1: 201.756,
    x2: 61.0831,
    y2: 189.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1604_25275",
    x1: 221.111,
    y1: 221.009,
    x2: 256.637,
    y2: 216.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1604_25275",
    x1: 224.049,
    y1: 221.01,
    x2: 258.162,
    y2: 215.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1604_25275",
    x1: 150.139,
    y1: 221.003,
    x2: 179.173,
    y2: 210.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1604_25275",
    x1: 140.068,
    y1: 221.003,
    x2: 169.103,
    y2: 210.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1604_25275",
    x1: 163.963,
    y1: 217.475,
    x2: 165.999,
    y2: 217.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1604_25275",
    x1: 150.139,
    y1: 211.626,
    x2: 179.173,
    y2: 201.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1604_25275",
    x1: 140.068,
    y1: 211.626,
    x2: 169.103,
    y2: 201.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1604_25275",
    x1: 163.957,
    y1: 208.084,
    x2: 165.994,
    y2: 207.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1604_25275",
    x1: 150.139,
    y1: 202.243,
    x2: 179.173,
    y2: 191.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1604_25275",
    x1: 140.068,
    y1: 202.243,
    x2: 169.103,
    y2: 191.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1604_25275",
    x1: 163.957,
    y1: 198.708,
    x2: 165.994,
    y2: 198.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1604_25275",
    x1: 150.139,
    y1: 192.859,
    x2: 179.173,
    y2: 182.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1604_25275",
    x1: 140.068,
    y1: 192.859,
    x2: 169.103,
    y2: 182.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1604_25275",
    x1: 163.957,
    y1: 189.325,
    x2: 165.994,
    y2: 189.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1604_25275",
    x1: 183.363,
    y1: 221.003,
    x2: 212.398,
    y2: 210.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1604_25275",
    x1: 173.301,
    y1: 221.003,
    x2: 202.335,
    y2: 210.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1604_25275",
    x1: 197.189,
    y1: 217.475,
    x2: 199.226,
    y2: 217.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1604_25275",
    x1: 183.363,
    y1: 211.626,
    x2: 212.398,
    y2: 201.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1604_25275",
    x1: 173.301,
    y1: 211.626,
    x2: 202.335,
    y2: 201.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1604_25275",
    x1: 197.189,
    y1: 208.091,
    x2: 199.226,
    y2: 207.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1604_25275",
    x1: 64.2129,
    y1: 203.001,
    x2: 107.497,
    y2: 201.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1604_25275",
    x1: 111.801,
    y1: 86.4749,
    x2: 114.831,
    y2: 86.2897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1604_25275",
    x1: 71.998,
    y1: 92.9813,
    x2: 82.5639,
    y2: 92.2631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1604_25275",
    x1: 67.6016,
    y1: 83.579,
    x2: 85.8971,
    y2: 80.3123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1604_25275",
    x1: 68.6035,
    y1: 106.492,
    x2: 81.9066,
    y2: 105.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1604_25275",
    x1: 68.9063,
    y1: 106.89,
    x2: 82.2109,
    y2: 105.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1604_25275",
    x1: 63.4004,
    y1: 103.888,
    x2: 66.7738,
    y2: 103.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1604_25275",
    x1: 117.516,
    y1: 79.4755,
    x2: 123.706,
    y2: 78.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1604_25275",
    x1: 106.535,
    y1: 92.3491,
    x2: 139.579,
    y2: 88.9102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1604_25275",
    x1: 120.852,
    y1: 80.4491,
    x2: 129.105,
    y2: 79.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1604_25275",
    x1: 130.443,
    y1: 84.2547,
    x2: 132.235,
    y2: 70.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1604_25275",
    x1: 131.336,
    y1: 77.1738,
    x2: 132.766,
    y2: 64.4971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1604_25275",
    x1: 125.229,
    y1: 70.8508,
    x2: 202.959,
    y2: 57.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1604_25275",
    x1: 125.229,
    y1: 134.713,
    x2: 221.364,
    y2: 116.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1604_25275",
    x1: 143.018,
    y1: 94.2459,
    x2: 186.268,
    y2: 83.3922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1604_25275",
    x1: 166.625,
    y1: 77.0412,
    x2: 210.111,
    y2: 66.1688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1604_25275",
    x1: 153.674,
    y1: 44.9265,
    x2: 210.793,
    y2: -14.4426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1604_25275",
    x1: 173.471,
    y1: 25.1419,
    x2: 236.859,
    y2: -1.41227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1604_25275",
    x1: 159.426,
    y1: 165.696,
    x2: 187.744,
    y2: 163.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1604_25275",
    x1: 177.818,
    y1: 134.327,
    x2: 248.459,
    y2: 100.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1604_25275",
    x1: 190.746,
    y1: 152.417,
    x2: 237.505,
    y2: 140.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1604_25275",
    x1: 237.846,
    y1: 11.1492,
    x2: 243.982,
    y2: 10.5016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1604_25275",
    x1: 196.322,
    y1: 31.3828,
    x2: 210.498,
    y2: 29.8868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1604_25275",
    x1: 199.986,
    y1: 27.5889,
    x2: 206.123,
    y2: 26.9413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1604_25275",
    x1: 257.998,
    y1: 47.2914,
    x2: 264.135,
    y2: 46.6438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1604_25275",
    x1: 205.482,
    y1: 62.3655,
    x2: 211.619,
    y2: 61.7179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1604_25275",
    x1: 232.961,
    y1: 83.2313,
    x2: 247.137,
    y2: 81.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1604_25275",
    x1: 236.625,
    y1: 79.4375,
    x2: 242.761,
    y2: 78.7899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1604_25275",
    x1: 181.666,
    y1: 96.5095,
    x2: 187.803,
    y2: 95.8619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1604_25275",
    x1: 253.113,
    y1: 119.905,
    x2: 259.25,
    y2: 119.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1604_25275",
    x1: 214.02,
    y1: 140.669,
    x2: 228.209,
    y2: 139.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1604_25275",
    x1: 217.695,
    y1: 136.869,
    x2: 223.832,
    y2: 136.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1604_25275",
    x1: 232.961,
    y1: 154.681,
    x2: 239.097,
    y2: 154.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1604_25275",
    x1: 181.861,
    y1: 168.181,
    x2: 188.011,
    y2: 167.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1604_25275",
    x1: 247.092,
    y1: 16.7893,
    x2: 260.363,
    y2: 15.7167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1604_25275",
    x1: 248.887,
    y1: 3.70067,
    x2: 253.343,
    y2: -0.977878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1604_25275",
    x1: 248.887,
    y1: 5.23718,
    x2: 253.343,
    y2: 0.558624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1604_25275",
    x1: 248.887,
    y1: 6.7799,
    x2: 253.343,
    y2: 2.10135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1604_25275",
    x1: 248.887,
    y1: 8.3164,
    x2: 253.343,
    y2: 3.63784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1604_25275",
    x1: 248.887,
    y1: 9.85924,
    x2: 253.343,
    y2: 5.18069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1604_25275",
    x1: 248.887,
    y1: 11.4021,
    x2: 253.343,
    y2: 6.72354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1604_25275",
    x1: 248.887,
    y1: 12.9386,
    x2: 253.343,
    y2: 8.26004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1604_25275",
    x1: 248.887,
    y1: 14.4814,
    x2: 253.036,
    y2: 11.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1604_25275",
    x1: 190.35,
    y1: 103.123,
    x2: 203.621,
    y2: 102.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1604_25275",
    x1: 192.145,
    y1: 90.0286,
    x2: 196.6,
    y2: 85.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1604_25275",
    x1: 192.145,
    y1: 91.5714,
    x2: 196.6,
    y2: 86.8928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1604_25275",
    x1: 192.145,
    y1: 93.1078,
    x2: 196.6,
    y2: 88.4292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1604_25275",
    x1: 192.145,
    y1: 94.6506,
    x2: 196.6,
    y2: 89.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1604_25275",
    x1: 192.145,
    y1: 96.187,
    x2: 196.601,
    y2: 91.5084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1604_25275",
    x1: 192.145,
    y1: 97.7299,
    x2: 196.6,
    y2: 93.0513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1604_25275",
    x1: 192.145,
    y1: 99.2727,
    x2: 196.6,
    y2: 94.5941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1604_25275",
    x1: 192.145,
    y1: 100.809,
    x2: 196.294,
    y2: 97.9866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1604_25275",
    x1: 260.795,
    y1: 120.645,
    x2: 274.066,
    y2: 119.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1604_25275",
    x1: 262.59,
    y1: 107.556,
    x2: 267.046,
    y2: 102.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1604_25275",
    x1: 262.59,
    y1: 109.092,
    x2: 267.046,
    y2: 104.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1604_25275",
    x1: 262.59,
    y1: 110.635,
    x2: 267.046,
    y2: 105.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1604_25275",
    x1: 262.59,
    y1: 112.178,
    x2: 267.046,
    y2: 107.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1604_25275",
    x1: 262.59,
    y1: 113.714,
    x2: 267.046,
    y2: 109.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1604_25275",
    x1: 262.59,
    y1: 115.257,
    x2: 267.046,
    y2: 110.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1604_25275",
    x1: 262.59,
    y1: 116.794,
    x2: 267.046,
    y2: 112.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1604_25275",
    x1: 262.59,
    y1: 118.337,
    x2: 266.739,
    y2: 115.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1604_25275",
    x1: 265.57,
    y1: 48.0059,
    x2: 278.842,
    y2: 46.9334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1604_25275",
    x1: 267.365,
    y1: 34.9172,
    x2: 271.821,
    y2: 30.2387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1604_25275",
    x1: 267.365,
    y1: 36.4537,
    x2: 271.821,
    y2: 31.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1604_25275",
    x1: 267.365,
    y1: 37.9966,
    x2: 271.821,
    y2: 33.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1604_25275",
    x1: 267.365,
    y1: 39.5394,
    x2: 271.821,
    y2: 34.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1604_25275",
    x1: 267.365,
    y1: 41.0759,
    x2: 271.821,
    y2: 36.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1604_25275",
    x1: 267.365,
    y1: 42.6188,
    x2: 271.821,
    y2: 37.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1604_25275",
    x1: 267.365,
    y1: 44.1551,
    x2: 271.821,
    y2: 39.4766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1604_25275",
    x1: 267.365,
    y1: 45.698,
    x2: 271.515,
    y2: 42.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1604_25275",
    x1: 190.576,
    y1: 178.316,
    x2: 203.848,
    y2: 177.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1604_25275",
    x1: 192.371,
    y1: 165.228,
    x2: 196.827,
    y2: 160.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1604_25275",
    x1: 192.371,
    y1: 166.764,
    x2: 196.827,
    y2: 162.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1604_25275",
    x1: 192.371,
    y1: 168.307,
    x2: 196.827,
    y2: 163.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1604_25275",
    x1: 192.371,
    y1: 169.844,
    x2: 196.827,
    y2: 165.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1604_25275",
    x1: 192.371,
    y1: 171.386,
    x2: 196.827,
    y2: 166.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1604_25275",
    x1: 192.371,
    y1: 172.929,
    x2: 196.827,
    y2: 168.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1604_25275",
    x1: 192.371,
    y1: 174.466,
    x2: 196.827,
    y2: 169.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1604_25275",
    x1: 192.371,
    y1: 176.009,
    x2: 196.52,
    y2: 173.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1604_25275",
    x1: 248.545,
    y1: 90.7368,
    x2: 279.361,
    y2: 87.4848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1604_25275",
    x1: 255.262,
    y1: 83.7814,
    x2: 271.34,
    y2: 82.0847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1604_25275",
    x1: 228.949,
    y1: 145.146,
    x2: 252.397,
    y2: 142.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1604_25275",
    x1: 212.602,
    y1: 38.6542,
    x2: 236.049,
    y2: 36.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1604_25275",
    x1: 213.127,
    y1: 65.6344,
    x2: 233.422,
    y2: 62.3415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1604_25275",
    x1: 213.811,
    y1: 65.0022,
    x2: 232.393,
    y2: 61.3374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1604_25275",
    x1: 243.049,
    y1: 162.06,
    x2: 263.344,
    y2: 158.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1604_25275",
    x1: 243.732,
    y1: 161.428,
    x2: 262.315,
    y2: 157.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPoints);
export default __webpack_public_path__ + "static/media/Data-Points.5b41e7f53efe1132bb5359c55d1c3478.svg";
export { ForwardRef as ReactComponent };